{
  "schemaVersion": 1,
  "campaignVersion": "campaign-v1",
  "puzzles": [
    {
      "id": "campaign-001",
      "levelId": 1,
      "size": 5,
      "regions": [
        [
          0,
          0,
          0,
          1,
          1
        ],
        [
          2,
          2,
          0,
          1,
          1
        ],
        [
          2,
          2,
          1,
          1,
          3
        ],
        [
          2,
          2,
          4,
          1,
          3
        ],
        [
          4,
          4,
          4,
          4,
          3
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 1
        },
        {
          "row": 3,
          "col": 4
        }
      ],
      "solutionColumns": [
        0,
        3,
        1,
        4,
        2
      ],
      "seed": "shibadoku-v1:1:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "512b051aa54b32d690203bf30c6caa3b9ee0526e436cc025b9396f751420922e",
      "difficulty": {
        "profileId": "5x5-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 51,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-002",
      "levelId": 2,
      "size": 5,
      "regions": [
        [
          0,
          0,
          0,
          1,
          1
        ],
        [
          0,
          0,
          2,
          1,
          1
        ],
        [
          3,
          2,
          2,
          1,
          4
        ],
        [
          3,
          3,
          4,
          4,
          4
        ],
        [
          3,
          3,
          4,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 1
        }
      ],
      "solutionColumns": [
        1,
        4,
        2,
        0,
        3
      ],
      "seed": "shibadoku-v1:2:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "e44d528f9d80f8fa11b865e7f34a6bb3b9a4769d3b7baf47679fa486e869e81c",
      "difficulty": {
        "profileId": "5x5-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 54,
        "logicalStepCount": 4
      }
    },
    {
      "id": "campaign-003",
      "levelId": 3,
      "size": 5,
      "regions": [
        [
          0,
          0,
          0,
          0,
          0
        ],
        [
          2,
          1,
          1,
          1,
          3
        ],
        [
          2,
          1,
          4,
          3,
          3
        ],
        [
          2,
          1,
          4,
          3,
          3
        ],
        [
          4,
          4,
          4,
          4,
          3
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 0
        },
        {
          "row": 1,
          "col": 3
        },
        {
          "row": 3,
          "col": 4
        }
      ],
      "solutionColumns": [
        1,
        3,
        0,
        4,
        2
      ],
      "seed": "shibadoku-v1:3:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "b8995a5ba8bbb1e913a7fbf6cdd4d61332fe6401d00bad61767dfffa0b3aa3ed",
      "difficulty": {
        "profileId": "5x5-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 57,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-004",
      "levelId": 4,
      "size": 5,
      "regions": [
        [
          1,
          1,
          1,
          2,
          0
        ],
        [
          1,
          1,
          1,
          2,
          0
        ],
        [
          3,
          1,
          1,
          2,
          0
        ],
        [
          3,
          3,
          4,
          2,
          0
        ],
        [
          3,
          4,
          4,
          4,
          0
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 3
        },
        {
          "row": 4,
          "col": 2
        }
      ],
      "solutionColumns": [
        4,
        1,
        3,
        0,
        2
      ],
      "seed": "shibadoku-v1:4:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "f2711f3260bfb1755c2bf3d9c60bc635d22faf635c7fbd383fbe57a536e3568a",
      "difficulty": {
        "profileId": "5x5-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 60,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-005",
      "levelId": 5,
      "size": 5,
      "regions": [
        [
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          3,
          2,
          2
        ],
        [
          3,
          3,
          3,
          2,
          2
        ],
        [
          4,
          4,
          3,
          2,
          2
        ]
      ],
      "givenShibas": [
        {
          "row": 4,
          "col": 0
        },
        {
          "row": 0,
          "col": 3
        }
      ],
      "solutionColumns": [
        3,
        1,
        4,
        2,
        0
      ],
      "seed": "shibadoku-v1:5:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "279fdf4ea4a8fd4cd97bb505dfec9c4e1e3e302c9de1ac6df0aafa525fef09dd",
      "difficulty": {
        "profileId": "5x5-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 63,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-006",
      "levelId": 6,
      "size": 5,
      "regions": [
        [
          1,
          0,
          0,
          0,
          3
        ],
        [
          1,
          2,
          2,
          2,
          3
        ],
        [
          1,
          2,
          2,
          2,
          3
        ],
        [
          4,
          4,
          2,
          3,
          3
        ],
        [
          4,
          4,
          4,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 4
        },
        {
          "row": 4,
          "col": 1
        },
        {
          "row": 2,
          "col": 2
        }
      ],
      "solutionColumns": [
        3,
        0,
        2,
        4,
        1
      ],
      "seed": "shibadoku-v1:6:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "79d3c228511bc0d5d3068fe80abd33ab551abc6332a822695397fb4a68616470",
      "difficulty": {
        "profileId": "5x5-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 66,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-007",
      "levelId": 7,
      "size": 5,
      "regions": [
        [
          2,
          0,
          0,
          1,
          1
        ],
        [
          2,
          0,
          1,
          1,
          1
        ],
        [
          2,
          2,
          3,
          3,
          4
        ],
        [
          2,
          3,
          3,
          3,
          4
        ],
        [
          2,
          2,
          3,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 4,
          "col": 4
        },
        {
          "row": 3,
          "col": 2
        }
      ],
      "solutionColumns": [
        1,
        3,
        0,
        2,
        4
      ],
      "seed": "shibadoku-v1:7:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "4f563c4bf448894a9cdde8243a0c29346b5758afc080bcf853a1bd5bff070c32",
      "difficulty": {
        "profileId": "5x5-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 69,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-008",
      "levelId": 8,
      "size": 5,
      "regions": [
        [
          1,
          1,
          1,
          0,
          0
        ],
        [
          2,
          1,
          1,
          1,
          0
        ],
        [
          2,
          2,
          1,
          3,
          0
        ],
        [
          2,
          2,
          4,
          3,
          3
        ],
        [
          4,
          4,
          4,
          3,
          3
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 3
        },
        {
          "row": 0,
          "col": 4
        }
      ],
      "solutionColumns": [
        4,
        2,
        0,
        3,
        1
      ],
      "seed": "shibadoku-v1:8:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "45b5332c9db2aed40fb5dc1a085c4be85be42857d80d743b71e97093f69a7810",
      "difficulty": {
        "profileId": "5x5-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 72,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-009",
      "levelId": 9,
      "size": 5,
      "regions": [
        [
          2,
          0,
          0,
          0,
          1
        ],
        [
          2,
          0,
          3,
          1,
          1
        ],
        [
          2,
          3,
          3,
          1,
          1
        ],
        [
          2,
          2,
          3,
          1,
          4
        ],
        [
          2,
          3,
          3,
          1,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 1,
          "col": 3
        },
        {
          "row": 3,
          "col": 2
        }
      ],
      "solutionColumns": [
        1,
        3,
        0,
        2,
        4
      ],
      "seed": "shibadoku-v1:9:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "47da44ab4462d39b54a92c702d45aa87f9bcbb0f02a7df130455581e29db42c8",
      "difficulty": {
        "profileId": "5x5-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 75,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-010",
      "levelId": 10,
      "size": 5,
      "regions": [
        [
          0,
          0,
          0,
          0,
          1
        ],
        [
          3,
          0,
          2,
          1,
          1
        ],
        [
          3,
          2,
          2,
          1,
          1
        ],
        [
          3,
          3,
          3,
          4,
          4
        ],
        [
          3,
          3,
          4,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 4,
          "col": 3
        },
        {
          "row": 1,
          "col": 4
        },
        {
          "row": 3,
          "col": 0
        }
      ],
      "solutionColumns": [
        1,
        4,
        2,
        0,
        3
      ],
      "seed": "shibadoku-v1:10:2",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "fe59bb3c52b8a9b13b02c81ad3c29d4ce744a9014a3277391ba534f7a8625f96",
      "difficulty": {
        "profileId": "5x5-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 51,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-011",
      "levelId": 11,
      "size": 5,
      "regions": [
        [
          0,
          0,
          1,
          1,
          1
        ],
        [
          2,
          0,
          0,
          1,
          1
        ],
        [
          2,
          2,
          0,
          1,
          1
        ],
        [
          3,
          3,
          3,
          4,
          4
        ],
        [
          3,
          3,
          3,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 2
        }
      ],
      "solutionColumns": [
        1,
        3,
        0,
        2,
        4
      ],
      "seed": "shibadoku-v1:11:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "39b936a65773f4454a6c346e2d5a62661208d32209322cd4acc4c425a70c2c50",
      "difficulty": {
        "profileId": "5x5-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 54,
        "logicalStepCount": 4
      }
    },
    {
      "id": "campaign-012",
      "levelId": 12,
      "size": 5,
      "regions": [
        [
          1,
          1,
          0,
          0,
          0
        ],
        [
          1,
          1,
          0,
          0,
          2
        ],
        [
          3,
          3,
          3,
          2,
          2
        ],
        [
          3,
          3,
          4,
          4,
          2
        ],
        [
          3,
          3,
          4,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 4,
          "col": 3
        },
        {
          "row": 3,
          "col": 1
        },
        {
          "row": 1,
          "col": 0
        }
      ],
      "solutionColumns": [
        2,
        0,
        4,
        1,
        3
      ],
      "seed": "shibadoku-v1:12:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "e4afacdc0fe534f900f660d3478e65d56e99f62fdeb1dd9e9d387e8c9535462b",
      "difficulty": {
        "profileId": "5x5-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 57,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-013",
      "levelId": 13,
      "size": 5,
      "regions": [
        [
          1,
          1,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          2,
          0
        ],
        [
          4,
          2,
          2,
          2,
          2
        ],
        [
          4,
          3,
          3,
          3,
          3
        ],
        [
          4,
          4,
          3,
          3,
          3
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 2
        }
      ],
      "solutionColumns": [
        3,
        1,
        4,
        2,
        0
      ],
      "seed": "shibadoku-v1:13:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "6e95d5304d8cdbd016ae4ee76fe1068d2eb504b29adc8424afbec3707f864c2e",
      "difficulty": {
        "profileId": "5x5-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 60,
        "logicalStepCount": 4
      }
    },
    {
      "id": "campaign-014",
      "levelId": 14,
      "size": 5,
      "regions": [
        [
          1,
          2,
          2,
          0,
          0
        ],
        [
          1,
          2,
          0,
          0,
          0
        ],
        [
          1,
          2,
          2,
          3,
          3
        ],
        [
          1,
          4,
          2,
          3,
          3
        ],
        [
          1,
          4,
          4,
          3,
          3
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 2
        }
      ],
      "solutionColumns": [
        3,
        0,
        2,
        4,
        1
      ],
      "seed": "shibadoku-v1:14:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "7439ed9234f43d6825beafe27da829b78de0dbd4c59babc8c625049aba91b7c9",
      "difficulty": {
        "profileId": "5x5-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 63,
        "logicalStepCount": 4
      }
    },
    {
      "id": "campaign-015",
      "levelId": 15,
      "size": 5,
      "regions": [
        [
          0,
          0,
          0,
          1,
          1
        ],
        [
          2,
          2,
          1,
          1,
          4
        ],
        [
          2,
          1,
          1,
          3,
          4
        ],
        [
          3,
          3,
          3,
          3,
          4
        ],
        [
          3,
          3,
          3,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 1
        },
        {
          "row": 2,
          "col": 0
        },
        {
          "row": 3,
          "col": 2
        }
      ],
      "solutionColumns": [
        1,
        3,
        0,
        2,
        4
      ],
      "seed": "shibadoku-v1:15:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "12c12133f00c078d66e62a67bcab01f4fb6f2fa00a2a8f8fa0cf08dc61715683",
      "difficulty": {
        "profileId": "5x5-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 66,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-016",
      "levelId": 16,
      "size": 5,
      "regions": [
        [
          0,
          0,
          2,
          1,
          1
        ],
        [
          3,
          0,
          2,
          1,
          1
        ],
        [
          3,
          2,
          2,
          4,
          1
        ],
        [
          3,
          3,
          2,
          4,
          4
        ],
        [
          3,
          3,
          4,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 4,
          "col": 3
        },
        {
          "row": 0,
          "col": 1
        }
      ],
      "solutionColumns": [
        1,
        4,
        2,
        0,
        3
      ],
      "seed": "shibadoku-v1:16:2",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "08f04e464310608437f7613b3270f57505d49fe116406a2edf3045235f5300a6",
      "difficulty": {
        "profileId": "5x5-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 69,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-017",
      "levelId": 17,
      "size": 5,
      "regions": [
        [
          1,
          1,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          2,
          2,
          0,
          3
        ],
        [
          4,
          4,
          2,
          0,
          3
        ],
        [
          4,
          4,
          4,
          3,
          3
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 2
        },
        {
          "row": 1,
          "col": 0
        }
      ],
      "solutionColumns": [
        3,
        0,
        2,
        4,
        1
      ],
      "seed": "shibadoku-v1:17:2",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "b1965ee38df6a0c29670c4f3eff6b9766c41c024365b6c1abeec9faa8aafcb96",
      "difficulty": {
        "profileId": "5x5-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 72,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-018",
      "levelId": 18,
      "size": 5,
      "regions": [
        [
          0,
          0,
          1,
          1,
          1
        ],
        [
          0,
          0,
          1,
          1,
          1
        ],
        [
          3,
          1,
          1,
          2,
          2
        ],
        [
          3,
          3,
          3,
          4,
          2
        ],
        [
          3,
          3,
          4,
          4,
          2
        ]
      ],
      "givenShibas": [
        {
          "row": 4,
          "col": 3
        },
        {
          "row": 1,
          "col": 2
        }
      ],
      "solutionColumns": [
        0,
        2,
        4,
        1,
        3
      ],
      "seed": "shibadoku-v1:18:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "ee1b9db55cf902c99836c5db4c30c67a323665cb88e82a2e25d8d35f3cac6f4e",
      "difficulty": {
        "profileId": "5x5-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 75,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-019",
      "levelId": 19,
      "size": 5,
      "regions": [
        [
          1,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          0,
          2,
          2
        ],
        [
          1,
          0,
          0,
          2,
          2
        ],
        [
          3,
          3,
          3,
          2,
          2
        ],
        [
          3,
          3,
          4,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 1
        },
        {
          "row": 2,
          "col": 3
        }
      ],
      "solutionColumns": [
        2,
        0,
        3,
        1,
        4
      ],
      "seed": "shibadoku-v1:19:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "5e4479b7b8f5c59df64c1d79973d0cd9facbebf565c8e346e0294aef5dd413d2",
      "difficulty": {
        "profileId": "5x5-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 51,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-020",
      "levelId": 20,
      "size": 5,
      "regions": [
        [
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          0,
          0,
          0,
          2
        ],
        [
          4,
          3,
          3,
          3,
          2
        ],
        [
          4,
          4,
          4,
          3,
          3
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 3
        },
        {
          "row": 2,
          "col": 4
        },
        {
          "row": 3,
          "col": 2
        }
      ],
      "solutionColumns": [
        3,
        1,
        4,
        2,
        0
      ],
      "seed": "shibadoku-v1:20:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "40b834270187f37b37724d5dac2093f8e7599751b2e17c1d6fcd221b69608475",
      "difficulty": {
        "profileId": "5x5-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 54,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-021",
      "levelId": 21,
      "size": 5,
      "regions": [
        [
          2,
          0,
          0,
          0,
          1
        ],
        [
          2,
          2,
          0,
          0,
          1
        ],
        [
          2,
          2,
          2,
          3,
          1
        ],
        [
          4,
          4,
          3,
          3,
          3
        ],
        [
          4,
          4,
          3,
          3,
          3
        ]
      ],
      "givenShibas": [
        {
          "row": 4,
          "col": 1
        },
        {
          "row": 1,
          "col": 4
        }
      ],
      "solutionColumns": [
        2,
        4,
        0,
        3,
        1
      ],
      "seed": "shibadoku-v1:21:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "bebfe574f15a00c78d8cfbff38bc84c349dde701006b81a24686cb704c6e0629",
      "difficulty": {
        "profileId": "5x5-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 57,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-022",
      "levelId": 22,
      "size": 5,
      "regions": [
        [
          2,
          0,
          0,
          0,
          1
        ],
        [
          2,
          2,
          0,
          3,
          1
        ],
        [
          2,
          2,
          3,
          3,
          1
        ],
        [
          4,
          4,
          4,
          3,
          3
        ],
        [
          4,
          4,
          4,
          3,
          3
        ]
      ],
      "givenShibas": [
        {
          "row": 1,
          "col": 4
        },
        {
          "row": 4,
          "col": 1
        }
      ],
      "solutionColumns": [
        2,
        4,
        0,
        3,
        1
      ],
      "seed": "shibadoku-v1:22:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "0463e00c6d9448b246f867d32355f0fdbca8b84d9826e6fc06662db1b4381f43",
      "difficulty": {
        "profileId": "5x5-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 60,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-023",
      "levelId": 23,
      "size": 5,
      "regions": [
        [
          0,
          0,
          0,
          0,
          1
        ],
        [
          4,
          2,
          1,
          1,
          1
        ],
        [
          4,
          2,
          2,
          3,
          1
        ],
        [
          4,
          2,
          3,
          3,
          3
        ],
        [
          4,
          3,
          3,
          3,
          3
        ]
      ],
      "givenShibas": [
        {
          "row": 4,
          "col": 0
        },
        {
          "row": 3,
          "col": 3
        }
      ],
      "solutionColumns": [
        2,
        4,
        1,
        3,
        0
      ],
      "seed": "shibadoku-v1:23:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "de2b4bb01ab6e4e4bda1b797b7b862dcfc7e214d5e2c3c2a06257c0377111385",
      "difficulty": {
        "profileId": "5x5-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 63,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-024",
      "levelId": 24,
      "size": 5,
      "regions": [
        [
          0,
          0,
          0,
          0,
          1
        ],
        [
          0,
          2,
          2,
          1,
          1
        ],
        [
          0,
          2,
          2,
          2,
          1
        ],
        [
          3,
          3,
          3,
          4,
          1
        ],
        [
          3,
          3,
          3,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 1,
          "col": 4
        },
        {
          "row": 4,
          "col": 3
        },
        {
          "row": 3,
          "col": 0
        }
      ],
      "solutionColumns": [
        1,
        4,
        2,
        0,
        3
      ],
      "seed": "shibadoku-v1:24:2",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "766a8e44d5f2ab6dd9b0b22503fb3bcddc829ae45d98b07367d6682133fcb5e5",
      "difficulty": {
        "profileId": "5x5-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 66,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-025",
      "levelId": 25,
      "size": 5,
      "regions": [
        [
          2,
          0,
          0,
          0,
          1
        ],
        [
          2,
          2,
          1,
          1,
          1
        ],
        [
          2,
          4,
          4,
          3,
          3
        ],
        [
          2,
          4,
          4,
          4,
          3
        ],
        [
          2,
          4,
          4,
          4,
          3
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 1
        },
        {
          "row": 4,
          "col": 2
        },
        {
          "row": 3,
          "col": 4
        }
      ],
      "solutionColumns": [
        1,
        3,
        0,
        4,
        2
      ],
      "seed": "shibadoku-v1:25:3",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "6361f053c305799f3cebe7a2007f3bb083de41b2aaf957fccdb0dccb46c0a67d",
      "difficulty": {
        "profileId": "5x5-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 69,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-026",
      "levelId": 26,
      "size": 5,
      "regions": [
        [
          0,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          0,
          2
        ],
        [
          4,
          1,
          3,
          3,
          2
        ],
        [
          4,
          1,
          3,
          2,
          2
        ],
        [
          4,
          4,
          3,
          2,
          2
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 3
        },
        {
          "row": 4,
          "col": 0
        }
      ],
      "solutionColumns": [
        3,
        1,
        4,
        2,
        0
      ],
      "seed": "shibadoku-v1:26:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "22e9b73f3ec269a9f86498ad9cb0fe3a35fba8bc18d556f880f8306db4d755f9",
      "difficulty": {
        "profileId": "5x5-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 72,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-027",
      "levelId": 27,
      "size": 5,
      "regions": [
        [
          1,
          0,
          0,
          2,
          2
        ],
        [
          1,
          0,
          0,
          0,
          2
        ],
        [
          1,
          1,
          0,
          2,
          2
        ],
        [
          3,
          3,
          3,
          3,
          4
        ],
        [
          3,
          3,
          3,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 2
        },
        {
          "row": 2,
          "col": 4
        }
      ],
      "solutionColumns": [
        2,
        0,
        4,
        1,
        3
      ],
      "seed": "shibadoku-v1:27:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "081c5cbeff330653a885f28587747f676d21a6468b742eebe36d13e91ff2f16d",
      "difficulty": {
        "profileId": "5x5-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 75,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-028",
      "levelId": 28,
      "size": 6,
      "regions": [
        [
          0,
          0,
          0,
          1,
          3,
          5
        ],
        [
          0,
          1,
          1,
          1,
          3,
          5
        ],
        [
          2,
          2,
          2,
          1,
          3,
          5
        ],
        [
          2,
          2,
          3,
          3,
          3,
          5
        ],
        [
          4,
          4,
          4,
          4,
          5,
          5
        ],
        [
          4,
          4,
          4,
          4,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 1
        },
        {
          "row": 1,
          "col": 3
        },
        {
          "row": 2,
          "col": 0
        },
        {
          "row": 3,
          "col": 4
        }
      ],
      "solutionColumns": [
        1,
        3,
        0,
        4,
        2,
        5
      ],
      "seed": "shibadoku-v1:28:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "415057726bef769bc70bd94c22eac8813b65282c57d0d47a836172c5000c43f1",
      "difficulty": {
        "profileId": "6x6-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 61,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-029",
      "levelId": 29,
      "size": 6,
      "regions": [
        [
          0,
          0,
          0,
          0,
          1,
          1
        ],
        [
          2,
          2,
          0,
          0,
          1,
          1
        ],
        [
          2,
          2,
          3,
          3,
          1,
          4
        ],
        [
          2,
          2,
          3,
          3,
          3,
          4
        ],
        [
          5,
          5,
          3,
          3,
          4,
          4
        ],
        [
          5,
          5,
          5,
          5,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 3
        },
        {
          "row": 0,
          "col": 2
        },
        {
          "row": 4,
          "col": 5
        },
        {
          "row": 2,
          "col": 1
        }
      ],
      "solutionColumns": [
        2,
        4,
        1,
        3,
        5,
        0
      ],
      "seed": "shibadoku-v1:29:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "8382fdd02693200a206a320fd1411d501a3ef92d6bedd02adce4cbea90987be5",
      "difficulty": {
        "profileId": "6x6-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 64,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-030",
      "levelId": 30,
      "size": 6,
      "regions": [
        [
          1,
          2,
          0,
          0,
          0,
          0
        ],
        [
          1,
          2,
          2,
          2,
          0,
          0
        ],
        [
          1,
          1,
          2,
          2,
          2,
          3
        ],
        [
          1,
          4,
          4,
          3,
          3,
          3
        ],
        [
          1,
          4,
          4,
          4,
          5,
          3
        ],
        [
          4,
          4,
          5,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 2
        },
        {
          "row": 3,
          "col": 5
        },
        {
          "row": 1,
          "col": 0
        },
        {
          "row": 0,
          "col": 3
        }
      ],
      "solutionColumns": [
        3,
        0,
        2,
        5,
        1,
        4
      ],
      "seed": "shibadoku-v1:30:2",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "5686b6318d9af5d44c69f9b91f3273c7dabf17626fdcfd16b1d8c27e1cd5a907",
      "difficulty": {
        "profileId": "6x6-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 67,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-031",
      "levelId": 31,
      "size": 6,
      "regions": [
        [
          1,
          1,
          1,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          0,
          0,
          2
        ],
        [
          4,
          1,
          3,
          0,
          0,
          2
        ],
        [
          4,
          1,
          3,
          3,
          2,
          2
        ],
        [
          4,
          4,
          5,
          3,
          2,
          2
        ],
        [
          4,
          4,
          5,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 5
        },
        {
          "row": 4,
          "col": 0
        },
        {
          "row": 3,
          "col": 3
        }
      ],
      "solutionColumns": [
        4,
        1,
        5,
        3,
        0,
        2
      ],
      "seed": "shibadoku-v1:31:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "e3860fe08c4228b69fb2b1d3f9eeaea044752c80e7b97c5fc9ece5b1523382f5",
      "difficulty": {
        "profileId": "6x6-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 70,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-032",
      "levelId": 32,
      "size": 6,
      "regions": [
        [
          2,
          0,
          0,
          1,
          1,
          1
        ],
        [
          2,
          0,
          0,
          0,
          1,
          1
        ],
        [
          2,
          0,
          0,
          0,
          3,
          3
        ],
        [
          2,
          5,
          5,
          3,
          3,
          3
        ],
        [
          2,
          5,
          5,
          5,
          4,
          4
        ],
        [
          2,
          2,
          5,
          5,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 5,
          "col": 2
        },
        {
          "row": 0,
          "col": 1
        }
      ],
      "solutionColumns": [
        1,
        4,
        0,
        3,
        5,
        2
      ],
      "seed": "shibadoku-v1:32:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "e5a9bf396200b8d4a71290c731103441b12526f38acc2c96b8b29f10aa2663f4",
      "difficulty": {
        "profileId": "6x6-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 73,
        "logicalStepCount": 4
      }
    },
    {
      "id": "campaign-033",
      "levelId": 33,
      "size": 6,
      "regions": [
        [
          1,
          1,
          1,
          0,
          0,
          0
        ],
        [
          2,
          1,
          1,
          1,
          0,
          0
        ],
        [
          2,
          2,
          1,
          4,
          0,
          0
        ],
        [
          2,
          2,
          3,
          4,
          4,
          4
        ],
        [
          2,
          3,
          3,
          3,
          4,
          4
        ],
        [
          5,
          5,
          5,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 4,
          "col": 4
        },
        {
          "row": 2,
          "col": 0
        }
      ],
      "solutionColumns": [
        5,
        3,
        0,
        2,
        4,
        1
      ],
      "seed": "shibadoku-v1:33:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "b05f47ec82d36baa86158c8f649d4339d83ce5922a828c1c9410731c4dceaf47",
      "difficulty": {
        "profileId": "6x6-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 76,
        "logicalStepCount": 4
      }
    },
    {
      "id": "campaign-034",
      "levelId": 34,
      "size": 6,
      "regions": [
        [
          0,
          0,
          1,
          1,
          2,
          2
        ],
        [
          0,
          0,
          1,
          1,
          1,
          2
        ],
        [
          0,
          3,
          3,
          1,
          4,
          2
        ],
        [
          3,
          3,
          3,
          3,
          4,
          2
        ],
        [
          3,
          5,
          5,
          4,
          4,
          4
        ],
        [
          5,
          5,
          5,
          4,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 1
        },
        {
          "row": 1,
          "col": 3
        }
      ],
      "solutionColumns": [
        0,
        3,
        5,
        1,
        4,
        2
      ],
      "seed": "shibadoku-v1:34:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "37322c912e1387a17a9a2026c394b319b98154accee0ae4d63d5fc41b84ef325",
      "difficulty": {
        "profileId": "6x6-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 79,
        "logicalStepCount": 4
      }
    },
    {
      "id": "campaign-035",
      "levelId": 35,
      "size": 6,
      "regions": [
        [
          0,
          0,
          0,
          0,
          1,
          1
        ],
        [
          2,
          0,
          0,
          2,
          1,
          1
        ],
        [
          2,
          2,
          2,
          2,
          3,
          1
        ],
        [
          4,
          2,
          2,
          5,
          3,
          3
        ],
        [
          4,
          4,
          4,
          5,
          5,
          3
        ],
        [
          4,
          4,
          5,
          5,
          5,
          3
        ]
      ],
      "givenShibas": [
        {
          "row": 1,
          "col": 5
        },
        {
          "row": 3,
          "col": 4
        },
        {
          "row": 2,
          "col": 2
        },
        {
          "row": 4,
          "col": 0
        }
      ],
      "solutionColumns": [
        1,
        5,
        2,
        4,
        0,
        3
      ],
      "seed": "shibadoku-v1:35:2",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "9d520966047ef0cc36c89e6e45a177ca65ec7662e4d8565366ef141da2eaa195",
      "difficulty": {
        "profileId": "6x6-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 82,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-036",
      "levelId": 36,
      "size": 6,
      "regions": [
        [
          0,
          0,
          0,
          0,
          2,
          2
        ],
        [
          0,
          1,
          1,
          1,
          2,
          2
        ],
        [
          0,
          3,
          1,
          1,
          2,
          2
        ],
        [
          3,
          3,
          3,
          3,
          2,
          4
        ],
        [
          3,
          5,
          5,
          5,
          4,
          4
        ],
        [
          3,
          5,
          5,
          5,
          5,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 1
        },
        {
          "row": 0,
          "col": 0
        },
        {
          "row": 4,
          "col": 5
        },
        {
          "row": 5,
          "col": 3
        }
      ],
      "solutionColumns": [
        0,
        2,
        4,
        1,
        5,
        3
      ],
      "seed": "shibadoku-v1:36:2",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "d00c4f2bb431bc4afef503115181195bfacda12ac6f51c1ee173d4c1f25f29b3",
      "difficulty": {
        "profileId": "6x6-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 85,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-037",
      "levelId": 37,
      "size": 6,
      "regions": [
        [
          0,
          0,
          0,
          0,
          1,
          1
        ],
        [
          4,
          2,
          2,
          1,
          1,
          1
        ],
        [
          4,
          2,
          2,
          3,
          1,
          3
        ],
        [
          4,
          2,
          3,
          3,
          3,
          3
        ],
        [
          4,
          5,
          5,
          5,
          3,
          5
        ],
        [
          4,
          5,
          5,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 5,
          "col": 5
        },
        {
          "row": 4,
          "col": 0
        },
        {
          "row": 3,
          "col": 3
        }
      ],
      "solutionColumns": [
        2,
        4,
        1,
        3,
        0,
        5
      ],
      "seed": "shibadoku-v1:37:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "b22e271811a15adc52cc836a181f7cadcd354f4ba35fa7157953b53667e17c44",
      "difficulty": {
        "profileId": "6x6-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 61,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-038",
      "levelId": 38,
      "size": 6,
      "regions": [
        [
          0,
          0,
          2,
          1,
          1,
          1
        ],
        [
          0,
          0,
          2,
          1,
          1,
          1
        ],
        [
          0,
          4,
          2,
          1,
          3,
          3
        ],
        [
          4,
          4,
          2,
          1,
          3,
          3
        ],
        [
          4,
          4,
          2,
          5,
          3,
          3
        ],
        [
          5,
          5,
          5,
          5,
          5,
          3
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 0
        },
        {
          "row": 5,
          "col": 3
        },
        {
          "row": 4,
          "col": 1
        },
        {
          "row": 3,
          "col": 5
        }
      ],
      "solutionColumns": [
        0,
        4,
        2,
        5,
        1,
        3
      ],
      "seed": "shibadoku-v1:38:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "3edaffae1bc795de85c8923b7914f6fa6e42d72111cd5f00d239400961c4183e",
      "difficulty": {
        "profileId": "6x6-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 64,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-039",
      "levelId": 39,
      "size": 6,
      "regions": [
        [
          0,
          0,
          1,
          1,
          1,
          3
        ],
        [
          0,
          0,
          1,
          1,
          3,
          3
        ],
        [
          0,
          2,
          1,
          1,
          3,
          3
        ],
        [
          2,
          2,
          2,
          4,
          3,
          5
        ],
        [
          2,
          2,
          4,
          4,
          5,
          5
        ],
        [
          2,
          2,
          4,
          4,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 4
        }
      ],
      "solutionColumns": [
        0,
        3,
        1,
        4,
        2,
        5
      ],
      "seed": "shibadoku-v1:39:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "80d35a2bf04316d7ec89a03f01f3e3b45597ebf1a377ee61b15e45f264a53fe7",
      "difficulty": {
        "profileId": "6x6-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 67,
        "logicalStepCount": 5
      }
    },
    {
      "id": "campaign-040",
      "levelId": 40,
      "size": 6,
      "regions": [
        [
          1,
          1,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          2,
          0,
          0,
          0
        ],
        [
          1,
          1,
          2,
          2,
          2,
          2
        ],
        [
          1,
          1,
          3,
          3,
          2,
          2
        ],
        [
          1,
          5,
          3,
          3,
          4,
          4
        ],
        [
          5,
          5,
          5,
          3,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 3
        },
        {
          "row": 4,
          "col": 5
        },
        {
          "row": 2,
          "col": 4
        },
        {
          "row": 1,
          "col": 0
        }
      ],
      "solutionColumns": [
        3,
        0,
        4,
        2,
        5,
        1
      ],
      "seed": "shibadoku-v1:40:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "0a711e7b094003c01fb02a830b7c316663b3453869b09d0668f46cacd29a81fb",
      "difficulty": {
        "profileId": "6x6-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 70,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-041",
      "levelId": 41,
      "size": 6,
      "regions": [
        [
          1,
          1,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          0,
          0,
          0
        ],
        [
          3,
          3,
          3,
          2,
          2,
          2
        ],
        [
          3,
          3,
          3,
          2,
          4,
          2
        ],
        [
          5,
          5,
          2,
          2,
          4,
          4
        ],
        [
          5,
          5,
          5,
          5,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 4
        },
        {
          "row": 0,
          "col": 3
        },
        {
          "row": 4,
          "col": 5
        },
        {
          "row": 3,
          "col": 1
        }
      ],
      "solutionColumns": [
        3,
        0,
        4,
        1,
        5,
        2
      ],
      "seed": "shibadoku-v1:41:2",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "16b0b3bd57f06df14c6004041630afa3670384ca25666131dbec0b282f323c5e",
      "difficulty": {
        "profileId": "6x6-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 73,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-042",
      "levelId": 42,
      "size": 6,
      "regions": [
        [
          2,
          2,
          1,
          1,
          0,
          0
        ],
        [
          2,
          1,
          1,
          1,
          0,
          3
        ],
        [
          2,
          2,
          3,
          1,
          0,
          3
        ],
        [
          5,
          2,
          3,
          3,
          3,
          3
        ],
        [
          5,
          5,
          5,
          4,
          4,
          4
        ],
        [
          5,
          5,
          4,
          4,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 4,
          "col": 3
        },
        {
          "row": 3,
          "col": 5
        },
        {
          "row": 1,
          "col": 2
        }
      ],
      "solutionColumns": [
        4,
        2,
        0,
        5,
        3,
        1
      ],
      "seed": "shibadoku-v1:42:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "0b22fb30e01c0ab60d53fe489b581c97643cf2b179f0af2f875be10fbfd2803c",
      "difficulty": {
        "profileId": "6x6-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 76,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-043",
      "levelId": 43,
      "size": 6,
      "regions": [
        [
          0,
          0,
          0,
          2,
          2,
          1
        ],
        [
          5,
          0,
          0,
          2,
          2,
          1
        ],
        [
          5,
          0,
          0,
          2,
          1,
          1
        ],
        [
          5,
          3,
          3,
          4,
          4,
          1
        ],
        [
          5,
          3,
          3,
          4,
          4,
          4
        ],
        [
          5,
          5,
          3,
          4,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 1,
          "col": 5
        },
        {
          "row": 5,
          "col": 0
        },
        {
          "row": 0,
          "col": 2
        }
      ],
      "solutionColumns": [
        2,
        5,
        3,
        1,
        4,
        0
      ],
      "seed": "shibadoku-v1:43:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "bd6e6dbdc5ae83ba78827d36386d04cbe68c07f46d318ea1efc3501c2b76cc5c",
      "difficulty": {
        "profileId": "6x6-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 79,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-044",
      "levelId": 44,
      "size": 6,
      "regions": [
        [
          1,
          1,
          0,
          0,
          0,
          0
        ],
        [
          2,
          1,
          1,
          1,
          3,
          0
        ],
        [
          2,
          2,
          5,
          5,
          3,
          3
        ],
        [
          2,
          4,
          5,
          5,
          3,
          3
        ],
        [
          2,
          4,
          5,
          5,
          3,
          3
        ],
        [
          4,
          4,
          4,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 0
        },
        {
          "row": 3,
          "col": 4
        },
        {
          "row": 4,
          "col": 1
        },
        {
          "row": 1,
          "col": 2
        }
      ],
      "solutionColumns": [
        5,
        2,
        0,
        4,
        1,
        3
      ],
      "seed": "shibadoku-v1:44:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "797c2ddb3c5b350620ad0653ff625ea7579571aa3e28b05551028d68623910d8",
      "difficulty": {
        "profileId": "6x6-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 82,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-045",
      "levelId": 45,
      "size": 6,
      "regions": [
        [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        [
          2,
          0,
          2,
          0,
          1,
          1
        ],
        [
          2,
          0,
          2,
          1,
          1,
          1
        ],
        [
          2,
          2,
          2,
          3,
          3,
          4
        ],
        [
          2,
          2,
          3,
          3,
          4,
          4
        ],
        [
          5,
          5,
          5,
          5,
          5,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 4,
          "col": 5
        },
        {
          "row": 1,
          "col": 4
        },
        {
          "row": 3,
          "col": 3
        },
        {
          "row": 5,
          "col": 1
        }
      ],
      "solutionColumns": [
        2,
        4,
        0,
        3,
        5,
        1
      ],
      "seed": "shibadoku-v1:45:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "d8984fc7aea5c6538a07a646cb46e2e10a5670f56e025bf6761de6fa7dc6497e",
      "difficulty": {
        "profileId": "6x6-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 85,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-046",
      "levelId": 46,
      "size": 6,
      "regions": [
        [
          0,
          0,
          0,
          1,
          1,
          3
        ],
        [
          0,
          2,
          1,
          1,
          1,
          3
        ],
        [
          2,
          2,
          2,
          2,
          2,
          3
        ],
        [
          4,
          2,
          4,
          5,
          3,
          3
        ],
        [
          4,
          4,
          4,
          5,
          3,
          5
        ],
        [
          4,
          4,
          5,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 2
        },
        {
          "row": 1,
          "col": 4
        },
        {
          "row": 4,
          "col": 1
        }
      ],
      "solutionColumns": [
        0,
        4,
        2,
        5,
        1,
        3
      ],
      "seed": "shibadoku-v1:46:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "e18f766e17d6109e4b8cf5ce6c5165cec86858023dce5c64626bdfd12ade5bc3",
      "difficulty": {
        "profileId": "6x6-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 61,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-047",
      "levelId": 47,
      "size": 6,
      "regions": [
        [
          3,
          1,
          0,
          0,
          0,
          2
        ],
        [
          3,
          1,
          1,
          1,
          0,
          2
        ],
        [
          3,
          1,
          1,
          1,
          2,
          2
        ],
        [
          3,
          5,
          5,
          4,
          2,
          2
        ],
        [
          3,
          5,
          5,
          4,
          4,
          4
        ],
        [
          3,
          5,
          4,
          4,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 4
        },
        {
          "row": 1,
          "col": 2
        },
        {
          "row": 4,
          "col": 3
        },
        {
          "row": 3,
          "col": 0
        }
      ],
      "solutionColumns": [
        4,
        2,
        5,
        0,
        3,
        1
      ],
      "seed": "shibadoku-v1:47:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "e5813c1d16eb3496e9bf94ed9066f7d43eb8e738f4e82fc770a4925131cff125",
      "difficulty": {
        "profileId": "6x6-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 64,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-048",
      "levelId": 48,
      "size": 6,
      "regions": [
        [
          3,
          1,
          1,
          1,
          0,
          0
        ],
        [
          3,
          3,
          1,
          1,
          2,
          0
        ],
        [
          3,
          3,
          1,
          1,
          2,
          2
        ],
        [
          5,
          3,
          3,
          2,
          2,
          2
        ],
        [
          5,
          3,
          4,
          4,
          2,
          2
        ],
        [
          5,
          5,
          5,
          4,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 1,
          "col": 2
        },
        {
          "row": 3,
          "col": 1
        },
        {
          "row": 2,
          "col": 4
        }
      ],
      "solutionColumns": [
        5,
        2,
        4,
        1,
        3,
        0
      ],
      "seed": "shibadoku-v1:48:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "784dccad1157ffc79194f801aa41d3d3ee8cedf04df1be57b4c4c97445481e87",
      "difficulty": {
        "profileId": "6x6-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 67,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-049",
      "levelId": 49,
      "size": 6,
      "regions": [
        [
          0,
          0,
          1,
          1,
          2,
          2
        ],
        [
          0,
          1,
          1,
          2,
          2,
          2
        ],
        [
          1,
          1,
          1,
          3,
          2,
          2
        ],
        [
          3,
          3,
          3,
          3,
          2,
          5
        ],
        [
          4,
          4,
          3,
          3,
          5,
          5
        ],
        [
          4,
          4,
          5,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 5
        },
        {
          "row": 5,
          "col": 4
        },
        {
          "row": 3,
          "col": 3
        },
        {
          "row": 0,
          "col": 0
        }
      ],
      "solutionColumns": [
        0,
        2,
        5,
        3,
        1,
        4
      ],
      "seed": "shibadoku-v1:49:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "218be6ed848b0188b0e3f67bec2732c6d990d4fbf2db30c2524e284ce209b124",
      "difficulty": {
        "profileId": "6x6-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 70,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-050",
      "levelId": 50,
      "size": 6,
      "regions": [
        [
          1,
          0,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          0,
          2,
          2
        ],
        [
          1,
          3,
          3,
          3,
          2,
          2
        ],
        [
          4,
          4,
          3,
          3,
          5,
          2
        ],
        [
          4,
          4,
          4,
          3,
          5,
          2
        ],
        [
          4,
          4,
          3,
          3,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 5,
          "col": 4
        },
        {
          "row": 1,
          "col": 0
        },
        {
          "row": 2,
          "col": 5
        },
        {
          "row": 3,
          "col": 3
        }
      ],
      "solutionColumns": [
        2,
        0,
        5,
        3,
        1,
        4
      ],
      "seed": "shibadoku-v1:50:2",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "4f1ecfe3473b6d0da71627d2a2a3064cdba98567eefff3ad6dfa302ed2469018",
      "difficulty": {
        "profileId": "6x6-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 73,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-051",
      "levelId": 51,
      "size": 6,
      "regions": [
        [
          0,
          0,
          0,
          0,
          1,
          1
        ],
        [
          2,
          2,
          0,
          1,
          1,
          1
        ],
        [
          2,
          2,
          2,
          2,
          2,
          3
        ],
        [
          4,
          4,
          4,
          2,
          3,
          3
        ],
        [
          4,
          4,
          5,
          5,
          3,
          3
        ],
        [
          4,
          5,
          5,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 1
        },
        {
          "row": 1,
          "col": 5
        },
        {
          "row": 0,
          "col": 3
        },
        {
          "row": 4,
          "col": 0
        }
      ],
      "solutionColumns": [
        3,
        5,
        1,
        4,
        0,
        2
      ],
      "seed": "shibadoku-v1:51:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "0bb85910a12135cc3a40b3dde15a7f85d05bc27a2c5a74e084e7d4183cc12b2a",
      "difficulty": {
        "profileId": "6x6-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 76,
        "logicalStepCount": 2
      }
    },
    {
      "id": "campaign-052",
      "levelId": 52,
      "size": 6,
      "regions": [
        [
          0,
          0,
          1,
          1,
          1,
          1
        ],
        [
          0,
          2,
          2,
          1,
          1,
          1
        ],
        [
          3,
          2,
          2,
          4,
          4,
          1
        ],
        [
          3,
          3,
          3,
          3,
          4,
          4
        ],
        [
          5,
          5,
          3,
          5,
          4,
          4
        ],
        [
          5,
          5,
          5,
          5,
          5,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 1,
          "col": 4
        },
        {
          "row": 4,
          "col": 5
        },
        {
          "row": 2,
          "col": 2
        }
      ],
      "solutionColumns": [
        1,
        4,
        2,
        0,
        5,
        3
      ],
      "seed": "shibadoku-v1:52:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "fec06a9c11aa626a768008072a12c681a501ee7ba248491e804694649884294a",
      "difficulty": {
        "profileId": "6x6-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 79,
        "logicalStepCount": 3
      }
    },
    {
      "id": "campaign-053",
      "levelId": 53,
      "size": 6,
      "regions": [
        [
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          2,
          1,
          1,
          1,
          0,
          0
        ],
        [
          2,
          4,
          4,
          3,
          0,
          3
        ],
        [
          2,
          4,
          4,
          3,
          3,
          3
        ],
        [
          2,
          4,
          4,
          5,
          3,
          3
        ],
        [
          2,
          5,
          5,
          5,
          5,
          3
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 4
        },
        {
          "row": 1,
          "col": 2
        }
      ],
      "solutionColumns": [
        5,
        2,
        0,
        4,
        1,
        3
      ],
      "seed": "shibadoku-v1:53:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "e453ad4e59e2cd8a29f3c8037c879e95ec64694d5099ea86fb66183da0f65072",
      "difficulty": {
        "profileId": "6x6-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 82,
        "logicalStepCount": 4
      }
    },
    {
      "id": "campaign-054",
      "levelId": 54,
      "size": 6,
      "regions": [
        [
          0,
          0,
          0,
          1,
          1,
          1
        ],
        [
          0,
          0,
          2,
          2,
          3,
          1
        ],
        [
          0,
          2,
          2,
          2,
          3,
          3
        ],
        [
          4,
          4,
          2,
          3,
          3,
          3
        ],
        [
          4,
          4,
          5,
          3,
          3,
          5
        ],
        [
          5,
          5,
          5,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 1
        },
        {
          "row": 5,
          "col": 3
        }
      ],
      "solutionColumns": [
        1,
        5,
        2,
        4,
        0,
        3
      ],
      "seed": "shibadoku-v1:54:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "d83ff1dfaf5105da670062663a5de4526a42e07605dac3488aa5187336570340",
      "difficulty": {
        "profileId": "6x6-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L1",
        "score": 85,
        "logicalStepCount": 4
      }
    },
    {
      "id": "campaign-055",
      "levelId": 55,
      "size": 7,
      "regions": [
        [
          1,
          1,
          2,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          2,
          2,
          0,
          4,
          0
        ],
        [
          1,
          1,
          2,
          2,
          4,
          4,
          4
        ],
        [
          5,
          1,
          2,
          2,
          4,
          3,
          3
        ],
        [
          5,
          5,
          5,
          6,
          4,
          3,
          3
        ],
        [
          5,
          5,
          5,
          6,
          6,
          6,
          3
        ],
        [
          5,
          6,
          6,
          6,
          6,
          3,
          3
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 6
        },
        {
          "row": 2,
          "col": 3
        }
      ],
      "solutionColumns": [
        5,
        1,
        3,
        6,
        4,
        0,
        2
      ],
      "seed": "shibadoku-v1:55:12",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "5ae7f1dfa8bd8776a6298819514d01fa57b8345bcf5f178970a9abf9de063064",
      "difficulty": {
        "profileId": "7x7-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 71,
        "logicalStepCount": 8
      }
    },
    {
      "id": "campaign-056",
      "levelId": 56,
      "size": 7,
      "regions": [
        [
          3,
          3,
          1,
          1,
          0,
          0,
          0
        ],
        [
          3,
          3,
          1,
          1,
          1,
          2,
          0
        ],
        [
          3,
          3,
          1,
          1,
          1,
          2,
          0
        ],
        [
          3,
          3,
          3,
          1,
          2,
          2,
          2
        ],
        [
          4,
          4,
          4,
          1,
          5,
          2,
          2
        ],
        [
          6,
          4,
          4,
          5,
          5,
          2,
          5
        ],
        [
          6,
          6,
          4,
          4,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 5
        },
        {
          "row": 3,
          "col": 0
        }
      ],
      "solutionColumns": [
        6,
        3,
        5,
        0,
        2,
        4,
        1
      ],
      "seed": "shibadoku-v1:56:15",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "b6f2c9575d211355e4d61aecd0e595a4eba4ce75494a1b57fc6a2aac0df219dd",
      "difficulty": {
        "profileId": "7x7-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 74,
        "logicalStepCount": 9
      }
    },
    {
      "id": "campaign-057",
      "levelId": 57,
      "size": 7,
      "regions": [
        [
          0,
          0,
          0,
          2,
          2,
          2,
          2
        ],
        [
          0,
          0,
          0,
          1,
          1,
          1,
          2
        ],
        [
          1,
          1,
          1,
          1,
          4,
          1,
          2
        ],
        [
          3,
          3,
          3,
          3,
          4,
          1,
          2
        ],
        [
          3,
          6,
          3,
          4,
          4,
          4,
          4
        ],
        [
          6,
          6,
          5,
          5,
          4,
          5,
          4
        ],
        [
          6,
          6,
          5,
          5,
          5,
          5,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 6
        },
        {
          "row": 5,
          "col": 2
        }
      ],
      "solutionColumns": [
        1,
        4,
        6,
        3,
        5,
        2,
        0
      ],
      "seed": "shibadoku-v1:57:51",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "20655203e0016c28738e064c1b994a1eacb4b9cd5aaac00299b2eb54403961ef",
      "difficulty": {
        "profileId": "7x7-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 77,
        "logicalStepCount": 10
      }
    },
    {
      "id": "campaign-058",
      "levelId": 58,
      "size": 7,
      "regions": [
        [
          0,
          0,
          0,
          1,
          1,
          1,
          1
        ],
        [
          0,
          0,
          0,
          0,
          1,
          1,
          1
        ],
        [
          2,
          2,
          2,
          3,
          3,
          4,
          4
        ],
        [
          2,
          2,
          3,
          3,
          3,
          4,
          4
        ],
        [
          5,
          5,
          3,
          5,
          3,
          4,
          4
        ],
        [
          5,
          5,
          5,
          5,
          5,
          6,
          6
        ],
        [
          5,
          5,
          6,
          6,
          6,
          6,
          6
        ]
      ],
      "givenShibas": [
        {
          "row": 5,
          "col": 0
        },
        {
          "row": 6,
          "col": 5
        }
      ],
      "solutionColumns": [
        2,
        4,
        1,
        3,
        6,
        0,
        5
      ],
      "seed": "shibadoku-v1:58:126",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "594768bd618133611a6699b84714943366afad0ea2c0869a0865a9e48d203d55",
      "difficulty": {
        "profileId": "7x7-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 82,
        "logicalStepCount": 11
      }
    },
    {
      "id": "campaign-059",
      "levelId": 59,
      "size": 7,
      "regions": [
        [
          2,
          2,
          2,
          1,
          1,
          0,
          0
        ],
        [
          2,
          2,
          2,
          2,
          1,
          1,
          0
        ],
        [
          2,
          2,
          2,
          2,
          1,
          1,
          1
        ],
        [
          4,
          4,
          5,
          5,
          3,
          3,
          1
        ],
        [
          4,
          4,
          5,
          5,
          3,
          3,
          3
        ],
        [
          6,
          4,
          5,
          5,
          5,
          5,
          3
        ],
        [
          6,
          6,
          6,
          5,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 1,
          "col": 4
        },
        {
          "row": 6,
          "col": 0
        }
      ],
      "solutionColumns": [
        6,
        4,
        2,
        5,
        1,
        3,
        0
      ],
      "seed": "shibadoku-v1:59:66",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "e01424a261a920ab11e7d8e27650b9cd4be15d413d4deb727dcba643d1802d65",
      "difficulty": {
        "profileId": "7x7-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 83,
        "logicalStepCount": 12
      }
    },
    {
      "id": "campaign-060",
      "levelId": 60,
      "size": 7,
      "regions": [
        [
          0,
          0,
          0,
          0,
          0,
          3,
          3
        ],
        [
          0,
          0,
          1,
          1,
          1,
          3,
          3
        ],
        [
          0,
          2,
          2,
          1,
          1,
          3,
          3
        ],
        [
          2,
          2,
          2,
          1,
          1,
          1,
          3
        ],
        [
          2,
          5,
          5,
          1,
          4,
          3,
          3
        ],
        [
          2,
          5,
          5,
          5,
          4,
          4,
          6
        ],
        [
          2,
          5,
          5,
          4,
          4,
          6,
          6
        ]
      ],
      "givenShibas": [
        {
          "row": 6,
          "col": 5
        },
        {
          "row": 2,
          "col": 1
        }
      ],
      "solutionColumns": [
        0,
        3,
        1,
        6,
        4,
        2,
        5
      ],
      "seed": "shibadoku-v1:60:3",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "cdd1bc842c30a0ad528aa5de45cb1482c5f1591cf7750cbbbcb5303114e09f10",
      "difficulty": {
        "profileId": "7x7-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 86,
        "logicalStepCount": 13
      }
    },
    {
      "id": "campaign-061",
      "levelId": 61,
      "size": 7,
      "regions": [
        [
          1,
          1,
          1,
          1,
          0,
          0,
          0
        ],
        [
          1,
          4,
          1,
          1,
          1,
          0,
          2
        ],
        [
          1,
          4,
          2,
          2,
          2,
          2,
          2
        ],
        [
          4,
          4,
          4,
          5,
          3,
          3,
          2
        ],
        [
          4,
          4,
          4,
          5,
          5,
          3,
          3
        ],
        [
          4,
          6,
          5,
          5,
          5,
          3,
          3
        ],
        [
          6,
          6,
          6,
          5,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 4
        },
        {
          "row": 4,
          "col": 0
        }
      ],
      "solutionColumns": [
        5,
        2,
        6,
        4,
        0,
        3,
        1
      ],
      "seed": "shibadoku-v1:61:26",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "68fe5eba214b2a740a7eb521d96aec8bfb619325fd6c5b9d90d1284382ed8bc5",
      "difficulty": {
        "profileId": "7x7-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 89,
        "logicalStepCount": 14
      }
    },
    {
      "id": "campaign-062",
      "levelId": 62,
      "size": 7,
      "regions": [
        [
          1,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          0,
          2,
          0,
          0,
          3
        ],
        [
          1,
          2,
          2,
          2,
          2,
          0,
          3
        ],
        [
          1,
          2,
          2,
          4,
          3,
          3,
          3
        ],
        [
          4,
          4,
          4,
          4,
          3,
          3,
          5
        ],
        [
          4,
          4,
          6,
          4,
          6,
          6,
          5
        ],
        [
          4,
          6,
          6,
          6,
          6,
          6,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 6,
          "col": 4
        },
        {
          "row": 0,
          "col": 3
        }
      ],
      "solutionColumns": [
        3,
        0,
        2,
        5,
        1,
        6,
        4
      ],
      "seed": "shibadoku-v1:62:22",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "e0fab41b6ff9c56ebe2db3594acd91a5242dd5e346cddee73af2271994fce81e",
      "difficulty": {
        "profileId": "7x7-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 92,
        "logicalStepCount": 15
      }
    },
    {
      "id": "campaign-063",
      "levelId": 63,
      "size": 7,
      "regions": [
        [
          2,
          2,
          2,
          2,
          2,
          0,
          0
        ],
        [
          1,
          1,
          2,
          2,
          0,
          0,
          4
        ],
        [
          1,
          2,
          2,
          3,
          3,
          4,
          4
        ],
        [
          1,
          6,
          2,
          3,
          3,
          4,
          4
        ],
        [
          6,
          6,
          6,
          5,
          5,
          4,
          4
        ],
        [
          6,
          6,
          6,
          5,
          5,
          5,
          5
        ],
        [
          6,
          6,
          6,
          6,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 5,
          "col": 3
        },
        {
          "row": 2,
          "col": 2
        }
      ],
      "solutionColumns": [
        5,
        0,
        2,
        4,
        6,
        3,
        1
      ],
      "seed": "shibadoku-v1:63:12",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "1c882cab0feb1e55448f2b5b926b15fbc571eecc1019159f6ffd8bdf6d5133e4",
      "difficulty": {
        "profileId": "7x7-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 95,
        "logicalStepCount": 16
      }
    },
    {
      "id": "campaign-064",
      "levelId": 64,
      "size": 7,
      "regions": [
        [
          1,
          0,
          0,
          0,
          0,
          3,
          3
        ],
        [
          1,
          1,
          0,
          0,
          2,
          4,
          3
        ],
        [
          1,
          1,
          2,
          2,
          2,
          4,
          3
        ],
        [
          1,
          5,
          2,
          2,
          2,
          4,
          3
        ],
        [
          5,
          5,
          5,
          2,
          4,
          4,
          3
        ],
        [
          5,
          5,
          5,
          6,
          4,
          6,
          3
        ],
        [
          5,
          5,
          6,
          6,
          6,
          6,
          6
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 6
        },
        {
          "row": 2,
          "col": 3
        }
      ],
      "solutionColumns": [
        2,
        0,
        3,
        6,
        4,
        1,
        5
      ],
      "seed": "shibadoku-v1:64:66",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "fbecd462763dc5d49d66a832ce571aa9b4d22a1e6b3ecfd2d6e1479293fad554",
      "difficulty": {
        "profileId": "7x7-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 71,
        "logicalStepCount": 8
      }
    },
    {
      "id": "campaign-065",
      "levelId": 65,
      "size": 7,
      "regions": [
        [
          1,
          1,
          0,
          0,
          0,
          2,
          2
        ],
        [
          1,
          1,
          0,
          0,
          0,
          2,
          2
        ],
        [
          1,
          1,
          1,
          5,
          0,
          2,
          2
        ],
        [
          4,
          1,
          4,
          5,
          3,
          3,
          3
        ],
        [
          4,
          4,
          4,
          5,
          3,
          3,
          3
        ],
        [
          4,
          4,
          5,
          5,
          6,
          3,
          6
        ],
        [
          4,
          4,
          5,
          5,
          6,
          6,
          6
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 4
        },
        {
          "row": 1,
          "col": 0
        }
      ],
      "solutionColumns": [
        2,
        0,
        6,
        4,
        1,
        3,
        5
      ],
      "seed": "shibadoku-v1:65:40",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "33d0caccbf9e23712591ad2d6d0486fbdeb21efc76c8ecc50e29da53f1c1f1ca",
      "difficulty": {
        "profileId": "7x7-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 74,
        "logicalStepCount": 9
      }
    },
    {
      "id": "campaign-066",
      "levelId": 66,
      "size": 7,
      "regions": [
        [
          1,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          0,
          2,
          0,
          2
        ],
        [
          1,
          3,
          3,
          2,
          2,
          2,
          2
        ],
        [
          1,
          3,
          3,
          3,
          3,
          3,
          2
        ],
        [
          4,
          5,
          5,
          5,
          6,
          6,
          2
        ],
        [
          4,
          5,
          5,
          6,
          6,
          6,
          6
        ],
        [
          4,
          5,
          6,
          6,
          6,
          6,
          6
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 5
        },
        {
          "row": 5,
          "col": 2
        }
      ],
      "solutionColumns": [
        5,
        1,
        6,
        3,
        0,
        2,
        4
      ],
      "seed": "shibadoku-v1:66:17",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "cf31cfdd51d693c83b6f4135447d31841db4b1e555ae9245694938425ce06664",
      "difficulty": {
        "profileId": "7x7-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 77,
        "logicalStepCount": 10
      }
    },
    {
      "id": "campaign-067",
      "levelId": 67,
      "size": 7,
      "regions": [
        [
          1,
          1,
          0,
          0,
          0,
          0,
          2
        ],
        [
          1,
          1,
          1,
          0,
          0,
          2,
          2
        ],
        [
          1,
          1,
          3,
          3,
          0,
          2,
          2
        ],
        [
          6,
          1,
          1,
          3,
          3,
          2,
          5
        ],
        [
          6,
          4,
          4,
          3,
          3,
          2,
          5
        ],
        [
          6,
          6,
          4,
          3,
          3,
          2,
          5
        ],
        [
          6,
          4,
          4,
          4,
          4,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 6,
          "col": 0
        },
        {
          "row": 1,
          "col": 2
        }
      ],
      "solutionColumns": [
        4,
        2,
        5,
        3,
        1,
        6,
        0
      ],
      "seed": "shibadoku-v1:67:13",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "0219f4a61a60f25705fa85a6e306228f394f49ce77e4c84b387c5abb4e5d12af",
      "difficulty": {
        "profileId": "7x7-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 80,
        "logicalStepCount": 11
      }
    },
    {
      "id": "campaign-068",
      "levelId": 68,
      "size": 7,
      "regions": [
        [
          1,
          1,
          1,
          0,
          0,
          0,
          2
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          2
        ],
        [
          3,
          3,
          1,
          3,
          3,
          3,
          2
        ],
        [
          3,
          3,
          3,
          3,
          3,
          4,
          2
        ],
        [
          6,
          6,
          4,
          4,
          4,
          4,
          2
        ],
        [
          6,
          6,
          6,
          4,
          5,
          5,
          5
        ],
        [
          6,
          6,
          6,
          5,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 1
        },
        {
          "row": 6,
          "col": 0
        }
      ],
      "solutionColumns": [
        4,
        2,
        6,
        1,
        3,
        5,
        0
      ],
      "seed": "shibadoku-v1:68:1",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "d91848adf06883e24eb656a6f11b5ab498b9140e2b34847f6b82ade275ac38c5",
      "difficulty": {
        "profileId": "7x7-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 83,
        "logicalStepCount": 12
      }
    },
    {
      "id": "campaign-069",
      "levelId": 69,
      "size": 7,
      "regions": [
        [
          2,
          2,
          1,
          1,
          1,
          1,
          0
        ],
        [
          2,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        [
          2,
          1,
          1,
          1,
          1,
          3,
          0
        ],
        [
          2,
          2,
          4,
          3,
          3,
          3,
          0
        ],
        [
          2,
          4,
          4,
          4,
          3,
          5,
          0
        ],
        [
          4,
          4,
          6,
          6,
          3,
          5,
          5
        ],
        [
          4,
          6,
          6,
          6,
          3,
          3,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 0
        },
        {
          "row": 0,
          "col": 6
        }
      ],
      "solutionColumns": [
        6,
        2,
        0,
        4,
        1,
        5,
        3
      ],
      "seed": "shibadoku-v1:69:5",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "e446127d401eee843928b6cfe640a8a1d6d38eb90cdcf790fe944a91494890a6",
      "difficulty": {
        "profileId": "7x7-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 86,
        "logicalStepCount": 13
      }
    },
    {
      "id": "campaign-070",
      "levelId": 70,
      "size": 7,
      "regions": [
        [
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          0,
          2,
          2,
          0,
          0
        ],
        [
          1,
          1,
          1,
          2,
          2,
          4,
          4
        ],
        [
          3,
          1,
          1,
          2,
          2,
          4,
          4
        ],
        [
          3,
          3,
          5,
          5,
          2,
          4,
          4
        ],
        [
          5,
          5,
          5,
          6,
          2,
          6,
          4
        ],
        [
          5,
          5,
          6,
          6,
          6,
          6,
          6
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 3
        },
        {
          "row": 4,
          "col": 6
        }
      ],
      "solutionColumns": [
        3,
        1,
        4,
        0,
        6,
        2,
        5
      ],
      "seed": "shibadoku-v1:70:51",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "140f901382c2cf5a7ade49f095233941752455371c03e5fb48b992ed3f214308",
      "difficulty": {
        "profileId": "7x7-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 89,
        "logicalStepCount": 14
      }
    },
    {
      "id": "campaign-071",
      "levelId": 71,
      "size": 7,
      "regions": [
        [
          1,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          0,
          3,
          3,
          2,
          0
        ],
        [
          1,
          1,
          3,
          3,
          2,
          2,
          2
        ],
        [
          1,
          1,
          1,
          3,
          4,
          2,
          4
        ],
        [
          1,
          1,
          1,
          4,
          4,
          4,
          4
        ],
        [
          5,
          5,
          5,
          4,
          6,
          4,
          6
        ],
        [
          5,
          5,
          5,
          5,
          6,
          6,
          6
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 2
        },
        {
          "row": 4,
          "col": 5
        }
      ],
      "solutionColumns": [
        2,
        0,
        6,
        3,
        5,
        1,
        4
      ],
      "seed": "shibadoku-v1:71:10",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "317ef6e3503d93bff22e42e558f0418ce93049324410f3c1518ac37c75d88c02",
      "difficulty": {
        "profileId": "7x7-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 92,
        "logicalStepCount": 15
      }
    },
    {
      "id": "campaign-072",
      "levelId": 72,
      "size": 7,
      "regions": [
        [
          1,
          1,
          1,
          1,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        [
          3,
          3,
          3,
          3,
          0,
          2,
          4
        ],
        [
          5,
          5,
          3,
          3,
          2,
          2,
          4
        ],
        [
          5,
          5,
          6,
          4,
          4,
          4,
          4
        ],
        [
          5,
          5,
          6,
          4,
          6,
          4,
          4
        ],
        [
          5,
          6,
          6,
          6,
          6,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 5,
          "col": 0
        },
        {
          "row": 3,
          "col": 3
        }
      ],
      "solutionColumns": [
        4,
        1,
        5,
        3,
        6,
        0,
        2
      ],
      "seed": "shibadoku-v1:72:3",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "487e026157be253dc9a120ccded33d17937e0d0d4a732d1c4acccf4df5ff56d7",
      "difficulty": {
        "profileId": "7x7-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 95,
        "logicalStepCount": 16
      }
    },
    {
      "id": "campaign-073",
      "levelId": 73,
      "size": 7,
      "regions": [
        [
          0,
          0,
          0,
          1,
          1,
          1,
          1
        ],
        [
          0,
          2,
          2,
          1,
          1,
          1,
          1
        ],
        [
          2,
          2,
          1,
          1,
          3,
          1,
          6
        ],
        [
          3,
          3,
          3,
          3,
          3,
          4,
          6
        ],
        [
          3,
          5,
          5,
          5,
          4,
          4,
          6
        ],
        [
          5,
          5,
          5,
          5,
          4,
          6,
          6
        ],
        [
          5,
          5,
          5,
          5,
          5,
          6,
          6
        ]
      ],
      "givenShibas": [
        {
          "row": 5,
          "col": 3
        },
        {
          "row": 3,
          "col": 2
        }
      ],
      "solutionColumns": [
        1,
        4,
        0,
        2,
        5,
        3,
        6
      ],
      "seed": "shibadoku-v1:73:33",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "79f7a4bb16dd7e09738e35d0d655795bed670a6e7acae889f574e35e0ea11dad",
      "difficulty": {
        "profileId": "7x7-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 71,
        "logicalStepCount": 8
      }
    },
    {
      "id": "campaign-074",
      "levelId": 74,
      "size": 7,
      "regions": [
        [
          0,
          0,
          0,
          0,
          0,
          2,
          2
        ],
        [
          0,
          1,
          1,
          1,
          2,
          2,
          2
        ],
        [
          0,
          3,
          1,
          4,
          2,
          2,
          2
        ],
        [
          3,
          3,
          1,
          4,
          4,
          2,
          5
        ],
        [
          3,
          3,
          4,
          4,
          4,
          5,
          5
        ],
        [
          3,
          3,
          4,
          4,
          6,
          5,
          5
        ],
        [
          3,
          3,
          6,
          6,
          6,
          6,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 1
        },
        {
          "row": 4,
          "col": 3
        }
      ],
      "solutionColumns": [
        0,
        2,
        5,
        1,
        3,
        6,
        4
      ],
      "seed": "shibadoku-v1:74:18",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "4358275501dafadb956f62d7e5448c241efaa8b0ff62868befa945bdd89088a9",
      "difficulty": {
        "profileId": "7x7-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 74,
        "logicalStepCount": 9
      }
    },
    {
      "id": "campaign-075",
      "levelId": 75,
      "size": 7,
      "regions": [
        [
          1,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          2,
          2,
          2,
          3,
          3
        ],
        [
          6,
          1,
          4,
          2,
          2,
          2,
          3
        ],
        [
          6,
          4,
          4,
          4,
          5,
          5,
          3
        ],
        [
          6,
          6,
          4,
          4,
          5,
          5,
          5
        ],
        [
          6,
          6,
          4,
          4,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 4
        },
        {
          "row": 6,
          "col": 0
        }
      ],
      "solutionColumns": [
        3,
        1,
        4,
        6,
        2,
        5,
        0
      ],
      "seed": "shibadoku-v1:75:82",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "8aa4de7665778a8c000716183bff425c9a2ba73895ac788b2dd74e3c25b4069a",
      "difficulty": {
        "profileId": "7x7-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 77,
        "logicalStepCount": 10
      }
    },
    {
      "id": "campaign-076",
      "levelId": 76,
      "size": 7,
      "regions": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          2,
          0,
          2,
          1,
          1,
          4,
          4
        ],
        [
          2,
          2,
          2,
          3,
          3,
          4,
          4
        ],
        [
          2,
          2,
          3,
          3,
          3,
          4,
          4
        ],
        [
          5,
          2,
          5,
          4,
          4,
          4,
          6
        ],
        [
          5,
          5,
          5,
          4,
          6,
          4,
          6
        ],
        [
          5,
          5,
          5,
          5,
          6,
          6,
          6
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 1
        }
      ],
      "solutionColumns": [
        1,
        4,
        0,
        3,
        5,
        2,
        6
      ],
      "seed": "shibadoku-v1:76:71",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "8ce93216ab3db060403483b4b6586bbdc13620060b0e9f7672ca13d3cb367f25",
      "difficulty": {
        "profileId": "7x7-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 80,
        "logicalStepCount": 11
      }
    },
    {
      "id": "campaign-077",
      "levelId": 77,
      "size": 7,
      "regions": [
        [
          0,
          0,
          0,
          1,
          1,
          3,
          3
        ],
        [
          2,
          2,
          0,
          1,
          1,
          3,
          3
        ],
        [
          2,
          2,
          0,
          0,
          4,
          3,
          3
        ],
        [
          2,
          2,
          2,
          4,
          4,
          4,
          3
        ],
        [
          2,
          2,
          5,
          5,
          4,
          4,
          4
        ],
        [
          5,
          5,
          5,
          5,
          6,
          6,
          6
        ],
        [
          5,
          5,
          6,
          6,
          6,
          6,
          6
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 1
        },
        {
          "row": 2,
          "col": 0
        }
      ],
      "solutionColumns": [
        1,
        3,
        0,
        6,
        4,
        2,
        5
      ],
      "seed": "shibadoku-v1:77:26",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "1498567e057412a448b5a0b03c2c7e0af923b5559952037b621399d5ec2b2202",
      "difficulty": {
        "profileId": "7x7-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 83,
        "logicalStepCount": 12
      }
    },
    {
      "id": "campaign-078",
      "levelId": 78,
      "size": 7,
      "regions": [
        [
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        [
          1,
          0,
          3,
          0,
          0,
          0,
          2
        ],
        [
          1,
          1,
          3,
          2,
          2,
          2,
          2
        ],
        [
          1,
          1,
          3,
          3,
          2,
          2,
          5
        ],
        [
          4,
          4,
          3,
          2,
          2,
          5,
          5
        ],
        [
          4,
          4,
          6,
          6,
          6,
          6,
          5
        ],
        [
          6,
          6,
          6,
          6,
          6,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 6,
          "col": 2
        },
        {
          "row": 5,
          "col": 6
        }
      ],
      "solutionColumns": [
        4,
        0,
        5,
        3,
        1,
        6,
        2
      ],
      "seed": "shibadoku-v1:78:84",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "d6a7e11ebb0a278afe0c4e468949916fca9ad60d9cea70b0603cf30a99b0bf7a",
      "difficulty": {
        "profileId": "7x7-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 86,
        "logicalStepCount": 13
      }
    },
    {
      "id": "campaign-079",
      "levelId": 79,
      "size": 7,
      "regions": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          2
        ],
        [
          0,
          0,
          1,
          1,
          2,
          2,
          2
        ],
        [
          0,
          0,
          1,
          3,
          2,
          2,
          2
        ],
        [
          0,
          0,
          3,
          3,
          3,
          4,
          4
        ],
        [
          3,
          3,
          3,
          4,
          4,
          4,
          4
        ],
        [
          5,
          5,
          5,
          4,
          4,
          6,
          6
        ],
        [
          5,
          5,
          5,
          5,
          6,
          6,
          6
        ]
      ],
      "givenShibas": [
        {
          "row": 6,
          "col": 5
        },
        {
          "row": 0,
          "col": 0
        }
      ],
      "solutionColumns": [
        0,
        3,
        6,
        2,
        4,
        1,
        5
      ],
      "seed": "shibadoku-v1:79:98",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "945def860eda7289398767657b8549b1328b8a403b3314f4500abb8b457032f9",
      "difficulty": {
        "profileId": "7x7-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 89,
        "logicalStepCount": 14
      }
    },
    {
      "id": "campaign-080",
      "levelId": 80,
      "size": 7,
      "regions": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          1,
          3,
          1,
          0,
          0,
          0,
          0
        ],
        [
          3,
          3,
          3,
          2,
          2,
          2,
          2
        ],
        [
          3,
          3,
          3,
          4,
          4,
          2,
          2
        ],
        [
          5,
          5,
          5,
          4,
          4,
          6,
          6
        ],
        [
          5,
          4,
          4,
          4,
          6,
          6,
          6
        ],
        [
          5,
          5,
          4,
          4,
          6,
          6,
          6
        ]
      ],
      "givenShibas": [
        {
          "row": 6,
          "col": 6
        },
        {
          "row": 1,
          "col": 2
        }
      ],
      "solutionColumns": [
        5,
        2,
        4,
        1,
        3,
        0,
        6
      ],
      "seed": "shibadoku-v1:80:2",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "e0263d84738821a99b1d9fcd96783201c59ccdcdd8ba3d82765945cdbaa8a5a3",
      "difficulty": {
        "profileId": "7x7-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 92,
        "logicalStepCount": 15
      }
    },
    {
      "id": "campaign-081",
      "levelId": 81,
      "size": 7,
      "regions": [
        [
          0,
          0,
          0,
          2,
          2,
          1,
          1
        ],
        [
          0,
          0,
          0,
          2,
          1,
          1,
          1
        ],
        [
          3,
          0,
          2,
          2,
          2,
          1,
          1
        ],
        [
          3,
          3,
          3,
          2,
          2,
          1,
          5
        ],
        [
          3,
          3,
          4,
          4,
          4,
          4,
          5
        ],
        [
          6,
          6,
          6,
          4,
          5,
          4,
          5
        ],
        [
          6,
          6,
          6,
          4,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 3
        },
        {
          "row": 6,
          "col": 1
        }
      ],
      "solutionColumns": [
        2,
        5,
        3,
        0,
        4,
        6,
        1
      ],
      "seed": "shibadoku-v1:81:31",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "06439061e7cb779acf29c81d91ddba8998a6eafbee7b9310b0b476de741fdc53",
      "difficulty": {
        "profileId": "7x7-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 95,
        "logicalStepCount": 16
      }
    },
    {
      "id": "campaign-082",
      "levelId": 82,
      "size": 8,
      "regions": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          5,
          5
        ],
        [
          2,
          2,
          3,
          1,
          1,
          1,
          5,
          5
        ],
        [
          2,
          2,
          3,
          3,
          1,
          1,
          5,
          5
        ],
        [
          2,
          2,
          3,
          3,
          4,
          1,
          5,
          5
        ],
        [
          4,
          4,
          4,
          4,
          4,
          5,
          5,
          5
        ],
        [
          4,
          6,
          6,
          4,
          4,
          6,
          5,
          5
        ],
        [
          4,
          6,
          6,
          6,
          6,
          6,
          7,
          7
        ],
        [
          6,
          6,
          6,
          6,
          7,
          7,
          7,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 0
        },
        {
          "row": 5,
          "col": 7
        }
      ],
      "solutionColumns": [
        1,
        5,
        0,
        2,
        4,
        7,
        3,
        6
      ],
      "seed": "shibadoku-v1:82:201",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "4dc2d0bf331477aa6173d55f0cf5dc49b66cc8491099fdec6c79b8b423448eae",
      "difficulty": {
        "profileId": "8x8-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 81,
        "logicalStepCount": 9
      }
    },
    {
      "id": "campaign-083",
      "levelId": 83,
      "size": 8,
      "regions": [
        [
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1
        ],
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1,
          1
        ],
        [
          0,
          0,
          2,
          2,
          2,
          4,
          1,
          1
        ],
        [
          0,
          3,
          3,
          2,
          2,
          4,
          4,
          4
        ],
        [
          3,
          3,
          2,
          2,
          2,
          4,
          5,
          5
        ],
        [
          3,
          3,
          2,
          2,
          4,
          4,
          5,
          5
        ],
        [
          3,
          3,
          6,
          6,
          6,
          6,
          7,
          5
        ],
        [
          6,
          6,
          6,
          6,
          6,
          7,
          7,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 5,
          "col": 7
        },
        {
          "row": 4,
          "col": 5
        }
      ],
      "solutionColumns": [
        0,
        2,
        4,
        1,
        5,
        7,
        3,
        6
      ],
      "seed": "shibadoku-v1:83:499",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "ff836a6f3b9b55a7612ae12157eb47a47bc93d7a4d60fb62216eb53b88cc5732",
      "difficulty": {
        "profileId": "8x8-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 85,
        "logicalStepCount": 10
      }
    },
    {
      "id": "campaign-084",
      "levelId": 84,
      "size": 8,
      "regions": [
        [
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1
        ],
        [
          4,
          0,
          0,
          2,
          1,
          1,
          1,
          1
        ],
        [
          4,
          0,
          0,
          2,
          1,
          1,
          3,
          3
        ],
        [
          4,
          2,
          2,
          2,
          2,
          1,
          3,
          3
        ],
        [
          4,
          4,
          6,
          6,
          3,
          3,
          3,
          3
        ],
        [
          7,
          4,
          6,
          6,
          5,
          5,
          5,
          5
        ],
        [
          7,
          7,
          6,
          6,
          5,
          5,
          5,
          5
        ],
        [
          7,
          7,
          7,
          7,
          7,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 7,
          "col": 0
        },
        {
          "row": 3,
          "col": 7
        }
      ],
      "solutionColumns": [
        4,
        6,
        3,
        7,
        1,
        5,
        2,
        0
      ],
      "seed": "shibadoku-v1:84:146",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "d8006a09766f6f5b634aca7b8a28629efa403c2705f05249bf8ea7587f822e47",
      "difficulty": {
        "profileId": "8x8-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 88,
        "logicalStepCount": 11
      }
    },
    {
      "id": "campaign-085",
      "levelId": 85,
      "size": 8,
      "regions": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0,
          0
        ],
        [
          1,
          4,
          4,
          1,
          1,
          0,
          0,
          2
        ],
        [
          5,
          4,
          1,
          1,
          1,
          3,
          3,
          2
        ],
        [
          5,
          4,
          4,
          4,
          3,
          3,
          3,
          3
        ],
        [
          5,
          5,
          4,
          4,
          4,
          3,
          3,
          3
        ],
        [
          5,
          7,
          7,
          4,
          4,
          4,
          4,
          3
        ],
        [
          5,
          7,
          7,
          6,
          6,
          6,
          6,
          6
        ],
        [
          5,
          7,
          6,
          6,
          6,
          6,
          6,
          6
        ]
      ],
      "givenShibas": [
        {
          "row": 1,
          "col": 4
        },
        {
          "row": 3,
          "col": 5
        }
      ],
      "solutionColumns": [
        6,
        4,
        7,
        5,
        2,
        0,
        3,
        1
      ],
      "seed": "shibadoku-v1:85:419",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "b1bfcf2e7b1fc6b3604ff372761be2cfa3408a4ea7b14152f859e4827d4eb492",
      "difficulty": {
        "profileId": "8x8-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 90,
        "logicalStepCount": 12
      }
    },
    {
      "id": "campaign-086",
      "levelId": 86,
      "size": 8,
      "regions": [
        [
          4,
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          4,
          4,
          1,
          1,
          1,
          1,
          0,
          2
        ],
        [
          4,
          4,
          1,
          6,
          1,
          3,
          2,
          2
        ],
        [
          4,
          5,
          5,
          6,
          3,
          3,
          2,
          3
        ],
        [
          4,
          4,
          5,
          6,
          6,
          3,
          3,
          3
        ],
        [
          4,
          5,
          5,
          6,
          6,
          6,
          3,
          3
        ],
        [
          4,
          5,
          5,
          6,
          6,
          6,
          6,
          6
        ],
        [
          7,
          7,
          7,
          7,
          6,
          6,
          6,
          6
        ]
      ],
      "givenShibas": [
        {
          "row": 4,
          "col": 0
        },
        {
          "row": 6,
          "col": 4
        }
      ],
      "solutionColumns": [
        6,
        3,
        7,
        5,
        0,
        2,
        4,
        1
      ],
      "seed": "shibadoku-v1:86:96",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "d138df2c4772b19d8914aa9f0d4c837299f72b38eaf37eaaca92479af54d3052",
      "difficulty": {
        "profileId": "8x8-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 95,
        "logicalStepCount": 13
      }
    },
    {
      "id": "campaign-087",
      "levelId": 87,
      "size": 8,
      "regions": [
        [
          3,
          3,
          1,
          1,
          1,
          2,
          0,
          0
        ],
        [
          3,
          3,
          1,
          1,
          1,
          2,
          2,
          0
        ],
        [
          3,
          3,
          1,
          4,
          1,
          2,
          2,
          0
        ],
        [
          3,
          3,
          4,
          4,
          4,
          4,
          4,
          0
        ],
        [
          3,
          3,
          5,
          5,
          4,
          4,
          4,
          0
        ],
        [
          5,
          5,
          5,
          7,
          7,
          4,
          7,
          7
        ],
        [
          6,
          6,
          5,
          7,
          7,
          7,
          7,
          7
        ],
        [
          6,
          6,
          5,
          5,
          7,
          7,
          7,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 7,
          "col": 6
        },
        {
          "row": 0,
          "col": 7
        }
      ],
      "solutionColumns": [
        7,
        3,
        5,
        1,
        4,
        2,
        0,
        6
      ],
      "seed": "shibadoku-v1:87:792",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "426f18b0ba901a5c133f0f0fb50135351daa9a1bb0b216a41d0bfe93c1f02ff9",
      "difficulty": {
        "profileId": "8x8-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 97,
        "logicalStepCount": 14
      }
    },
    {
      "id": "campaign-088",
      "levelId": 88,
      "size": 8,
      "regions": [
        [
          1,
          1,
          1,
          0,
          0,
          0,
          0,
          2
        ],
        [
          1,
          1,
          1,
          1,
          0,
          0,
          0,
          2
        ],
        [
          1,
          4,
          1,
          4,
          4,
          0,
          2,
          2
        ],
        [
          4,
          4,
          4,
          4,
          3,
          3,
          2,
          2
        ],
        [
          6,
          6,
          4,
          3,
          3,
          3,
          3,
          2
        ],
        [
          6,
          6,
          4,
          3,
          5,
          5,
          3,
          3
        ],
        [
          6,
          6,
          6,
          7,
          5,
          5,
          5,
          5
        ],
        [
          6,
          7,
          7,
          7,
          7,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 4
        },
        {
          "row": 1,
          "col": 0
        }
      ],
      "solutionColumns": [
        6,
        0,
        7,
        4,
        2,
        5,
        1,
        3
      ],
      "seed": "shibadoku-v1:88:367",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "5ccfb8b4dc2d1564519c6b73d705387d103891f63322c3bdae3ecf7c256e22f7",
      "difficulty": {
        "profileId": "8x8-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 99,
        "logicalStepCount": 15
      }
    },
    {
      "id": "campaign-089",
      "levelId": 89,
      "size": 8,
      "regions": [
        [
          1,
          0,
          0,
          0,
          3,
          3,
          3,
          2
        ],
        [
          1,
          1,
          1,
          1,
          3,
          2,
          2,
          2
        ],
        [
          1,
          1,
          1,
          1,
          3,
          3,
          2,
          2
        ],
        [
          6,
          1,
          6,
          6,
          3,
          2,
          2,
          4
        ],
        [
          6,
          6,
          6,
          3,
          3,
          5,
          2,
          4
        ],
        [
          6,
          6,
          6,
          7,
          7,
          5,
          5,
          4
        ],
        [
          6,
          6,
          6,
          6,
          7,
          5,
          5,
          5
        ],
        [
          6,
          6,
          7,
          7,
          7,
          7,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 5,
          "col": 5
        },
        {
          "row": 1,
          "col": 0
        }
      ],
      "solutionColumns": [
        2,
        0,
        6,
        4,
        7,
        5,
        1,
        3
      ],
      "seed": "shibadoku-v1:89:146",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "32428ae0a53d0bd9d1f046cabef8d9fe70958b69cdca9fed964276b47cbea533",
      "difficulty": {
        "profileId": "8x8-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 102,
        "logicalStepCount": 16
      }
    },
    {
      "id": "campaign-090",
      "levelId": 90,
      "size": 8,
      "regions": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          1,
          1
        ],
        [
          0,
          0,
          1,
          1,
          2,
          2,
          2,
          2
        ],
        [
          0,
          0,
          4,
          2,
          2,
          2,
          2,
          2
        ],
        [
          3,
          3,
          4,
          4,
          4,
          4,
          2,
          2
        ],
        [
          3,
          3,
          3,
          4,
          4,
          4,
          5,
          5
        ],
        [
          3,
          3,
          3,
          6,
          6,
          5,
          5,
          5
        ],
        [
          6,
          6,
          6,
          6,
          6,
          5,
          7,
          7
        ],
        [
          6,
          6,
          6,
          6,
          6,
          6,
          7,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 1,
          "col": 2
        },
        {
          "row": 2,
          "col": 4
        }
      ],
      "solutionColumns": [
        0,
        2,
        4,
        1,
        5,
        7,
        3,
        6
      ],
      "seed": "shibadoku-v1:90:269",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "2d9bcd4e6968686ce6f4cec7a1b77d88d7c6d615af64429562342615b999df77",
      "difficulty": {
        "profileId": "8x8-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 105,
        "logicalStepCount": 17
      }
    },
    {
      "id": "campaign-091",
      "levelId": 91,
      "size": 8,
      "regions": [
        [
          2,
          2,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        [
          2,
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          2,
          2,
          2,
          2,
          4,
          1,
          0,
          0
        ],
        [
          2,
          3,
          3,
          2,
          4,
          4,
          0,
          5
        ],
        [
          3,
          3,
          3,
          3,
          4,
          4,
          5,
          5
        ],
        [
          6,
          6,
          3,
          3,
          3,
          4,
          5,
          5
        ],
        [
          6,
          6,
          6,
          3,
          4,
          4,
          7,
          7
        ],
        [
          6,
          6,
          6,
          6,
          4,
          7,
          7,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 7,
          "col": 7
        },
        {
          "row": 4,
          "col": 4
        }
      ],
      "solutionColumns": [
        5,
        3,
        0,
        2,
        4,
        6,
        1,
        7
      ],
      "seed": "shibadoku-v1:91:16",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "609ca85fa70f4c3d8363addb90cf9091424b0edbe543b883a3b76eb4923957a8",
      "difficulty": {
        "profileId": "8x8-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 83,
        "logicalStepCount": 9
      }
    },
    {
      "id": "campaign-092",
      "levelId": 92,
      "size": 8,
      "regions": [
        [
          0,
          0,
          1,
          1,
          1,
          1,
          2,
          2
        ],
        [
          0,
          0,
          0,
          1,
          1,
          2,
          2,
          2
        ],
        [
          3,
          3,
          0,
          0,
          2,
          2,
          2,
          2
        ],
        [
          6,
          3,
          3,
          3,
          5,
          2,
          2,
          4
        ],
        [
          6,
          3,
          3,
          5,
          5,
          4,
          4,
          4
        ],
        [
          6,
          6,
          6,
          5,
          5,
          5,
          4,
          4
        ],
        [
          6,
          6,
          7,
          7,
          7,
          5,
          4,
          4
        ],
        [
          7,
          7,
          7,
          7,
          7,
          5,
          5,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 6,
          "col": 1
        },
        {
          "row": 1,
          "col": 3
        }
      ],
      "solutionColumns": [
        0,
        3,
        6,
        2,
        7,
        5,
        1,
        4
      ],
      "seed": "shibadoku-v1:92:260",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "387bf4f045c37f8334d07c0dd45db626001876dcfaaa9c1f7952c1a003d3880f",
      "difficulty": {
        "profileId": "8x8-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 85,
        "logicalStepCount": 10
      }
    },
    {
      "id": "campaign-093",
      "levelId": 93,
      "size": 8,
      "regions": [
        [
          0,
          2,
          2,
          1,
          1,
          1,
          1,
          1
        ],
        [
          0,
          2,
          2,
          3,
          3,
          1,
          1,
          1
        ],
        [
          0,
          2,
          2,
          3,
          3,
          3,
          3,
          3
        ],
        [
          4,
          4,
          4,
          3,
          3,
          3,
          7,
          3
        ],
        [
          4,
          4,
          4,
          3,
          3,
          3,
          7,
          7
        ],
        [
          4,
          6,
          6,
          6,
          6,
          6,
          5,
          7
        ],
        [
          6,
          6,
          6,
          6,
          5,
          5,
          5,
          7
        ],
        [
          6,
          5,
          5,
          5,
          5,
          5,
          5,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 1
        },
        {
          "row": 7,
          "col": 7
        }
      ],
      "solutionColumns": [
        0,
        5,
        1,
        4,
        2,
        6,
        3,
        7
      ],
      "seed": "shibadoku-v1:93:35",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "0b6ced54c444caf80a359945f56b002e2d0e7b67f57848d73cb351cfa9c34685",
      "difficulty": {
        "profileId": "8x8-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 87,
        "logicalStepCount": 11
      }
    },
    {
      "id": "campaign-094",
      "levelId": 94,
      "size": 8,
      "regions": [
        [
          0,
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          2,
          0,
          0,
          1,
          1,
          1,
          1,
          1
        ],
        [
          2,
          0,
          0,
          1,
          1,
          1,
          4,
          4
        ],
        [
          2,
          0,
          3,
          1,
          1,
          4,
          4,
          4
        ],
        [
          2,
          0,
          3,
          3,
          3,
          5,
          4,
          4
        ],
        [
          2,
          3,
          3,
          3,
          5,
          5,
          6,
          6
        ],
        [
          7,
          7,
          7,
          5,
          5,
          5,
          6,
          6
        ],
        [
          7,
          7,
          7,
          7,
          7,
          5,
          6,
          6
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 1
        },
        {
          "row": 4,
          "col": 7
        }
      ],
      "solutionColumns": [
        1,
        5,
        0,
        2,
        7,
        4,
        6,
        3
      ],
      "seed": "shibadoku-v1:94:74",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "c14973d36a78d551c765f0a0ddb724ef24efd23ef9973e2fa4970aaa20fe1971",
      "difficulty": {
        "profileId": "8x8-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 90,
        "logicalStepCount": 12
      }
    },
    {
      "id": "campaign-095",
      "levelId": 95,
      "size": 8,
      "regions": [
        [
          1,
          1,
          1,
          1,
          0,
          0,
          0,
          2
        ],
        [
          1,
          1,
          1,
          1,
          0,
          0,
          0,
          2
        ],
        [
          1,
          1,
          4,
          4,
          2,
          2,
          2,
          2
        ],
        [
          4,
          4,
          4,
          4,
          4,
          3,
          3,
          3
        ],
        [
          5,
          4,
          4,
          5,
          4,
          3,
          3,
          3
        ],
        [
          5,
          5,
          5,
          5,
          6,
          6,
          3,
          3
        ],
        [
          5,
          5,
          6,
          6,
          6,
          6,
          7,
          7
        ],
        [
          5,
          5,
          6,
          6,
          6,
          7,
          7,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 6
        },
        {
          "row": 7,
          "col": 7
        }
      ],
      "solutionColumns": [
        5,
        1,
        4,
        6,
        2,
        0,
        3,
        7
      ],
      "seed": "shibadoku-v1:95:98",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "2b698d4304ad7f2b1398e8c8a76c5529816e313af2356044745517d89c17eeec",
      "difficulty": {
        "profileId": "8x8-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 94,
        "logicalStepCount": 13
      }
    },
    {
      "id": "campaign-096",
      "levelId": 96,
      "size": 8,
      "regions": [
        [
          1,
          1,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          1,
          2,
          2,
          0,
          0
        ],
        [
          1,
          1,
          1,
          1,
          2,
          2,
          3,
          3
        ],
        [
          5,
          5,
          1,
          1,
          4,
          2,
          2,
          3
        ],
        [
          5,
          5,
          4,
          4,
          4,
          4,
          3,
          3
        ],
        [
          5,
          5,
          6,
          6,
          4,
          4,
          4,
          4
        ],
        [
          5,
          5,
          6,
          6,
          6,
          4,
          4,
          4
        ],
        [
          5,
          7,
          7,
          7,
          6,
          6,
          4,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 1,
          "col": 2
        },
        {
          "row": 4,
          "col": 4
        }
      ],
      "solutionColumns": [
        6,
        2,
        5,
        7,
        4,
        0,
        3,
        1
      ],
      "seed": "shibadoku-v1:96:239",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "249eb2c78e7a03677ac291cfc83244b92125bce4cb2cd00ab56c652f684f13cb",
      "difficulty": {
        "profileId": "8x8-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 96,
        "logicalStepCount": 14
      }
    },
    {
      "id": "campaign-097",
      "levelId": 97,
      "size": 8,
      "regions": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          4,
          4,
          4,
          1,
          1,
          1,
          2,
          2
        ],
        [
          4,
          4,
          4,
          1,
          3,
          2,
          2,
          2
        ],
        [
          5,
          4,
          4,
          3,
          3,
          3,
          2,
          2
        ],
        [
          5,
          4,
          4,
          3,
          3,
          6,
          2,
          2
        ],
        [
          5,
          5,
          7,
          3,
          3,
          6,
          6,
          6
        ],
        [
          7,
          5,
          7,
          6,
          6,
          6,
          6,
          6
        ],
        [
          7,
          7,
          7,
          7,
          6,
          6,
          6,
          6
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 4
        },
        {
          "row": 2,
          "col": 6
        }
      ],
      "solutionColumns": [
        7,
        3,
        6,
        4,
        2,
        0,
        5,
        1
      ],
      "seed": "shibadoku-v1:97:225",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "2cdeeeeb6b9920d48fad05a2f2559ef29c54ab05a38992772230fa739226dac7",
      "difficulty": {
        "profileId": "8x8-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 99,
        "logicalStepCount": 15
      }
    },
    {
      "id": "campaign-098",
      "levelId": 98,
      "size": 8,
      "regions": [
        [
          1,
          1,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          3,
          0,
          0,
          2,
          2
        ],
        [
          1,
          1,
          3,
          3,
          2,
          2,
          2,
          2
        ],
        [
          1,
          3,
          3,
          3,
          2,
          4,
          2,
          2
        ],
        [
          3,
          3,
          5,
          3,
          4,
          4,
          4,
          7
        ],
        [
          3,
          3,
          5,
          6,
          6,
          4,
          4,
          7
        ],
        [
          5,
          5,
          5,
          6,
          6,
          6,
          4,
          7
        ],
        [
          5,
          5,
          5,
          5,
          5,
          6,
          7,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 6,
          "col": 4
        },
        {
          "row": 2,
          "col": 5
        }
      ],
      "solutionColumns": [
        3,
        0,
        5,
        1,
        6,
        2,
        4,
        7
      ],
      "seed": "shibadoku-v1:98:7",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "e7a2e891ec8ccf846fc1c896ab01006335985bce4c802ef0bd2d000c3aa3b98d",
      "difficulty": {
        "profileId": "8x8-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 102,
        "logicalStepCount": 16
      }
    },
    {
      "id": "campaign-099",
      "levelId": 99,
      "size": 8,
      "regions": [
        [
          1,
          1,
          1,
          2,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          2,
          2,
          2,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          2,
          2,
          0,
          0,
          0
        ],
        [
          4,
          4,
          1,
          1,
          2,
          2,
          3,
          0
        ],
        [
          4,
          4,
          4,
          6,
          2,
          3,
          3,
          3
        ],
        [
          7,
          4,
          6,
          6,
          3,
          3,
          3,
          5
        ],
        [
          7,
          6,
          6,
          6,
          6,
          3,
          3,
          5
        ],
        [
          7,
          7,
          7,
          7,
          7,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 6,
          "col": 3
        },
        {
          "row": 1,
          "col": 0
        }
      ],
      "solutionColumns": [
        5,
        0,
        4,
        6,
        2,
        7,
        3,
        1
      ],
      "seed": "shibadoku-v1:99:319",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "72ff847bc8eb0e4a792d79529bbdaaf20c3443ddc25ce2069c79f4b5dce3afba",
      "difficulty": {
        "profileId": "8x8-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 105,
        "logicalStepCount": 17
      }
    },
    {
      "id": "campaign-100",
      "levelId": 100,
      "size": 8,
      "regions": [
        [
          1,
          1,
          2,
          2,
          2,
          2,
          0,
          0
        ],
        [
          1,
          1,
          1,
          2,
          2,
          2,
          2,
          0
        ],
        [
          1,
          4,
          1,
          4,
          4,
          2,
          3,
          3
        ],
        [
          5,
          4,
          4,
          4,
          3,
          3,
          3,
          3
        ],
        [
          5,
          5,
          4,
          4,
          4,
          6,
          3,
          3
        ],
        [
          5,
          5,
          6,
          6,
          4,
          6,
          3,
          3
        ],
        [
          5,
          5,
          7,
          6,
          6,
          6,
          3,
          3
        ],
        [
          5,
          5,
          7,
          7,
          6,
          6,
          3,
          3
        ]
      ],
      "givenShibas": [
        {
          "row": 1,
          "col": 0
        },
        {
          "row": 3,
          "col": 7
        }
      ],
      "solutionColumns": [
        6,
        0,
        5,
        7,
        3,
        1,
        4,
        2
      ],
      "seed": "shibadoku-v1:100:202",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "ba502ef4cf396c7ea710906a5ff456a5c358a193007a7328c0e9e45ac31dd128",
      "difficulty": {
        "profileId": "8x8-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 81,
        "logicalStepCount": 9
      }
    },
    {
      "id": "campaign-101",
      "levelId": 101,
      "size": 8,
      "regions": [
        [
          3,
          3,
          2,
          2,
          0,
          0,
          0,
          0
        ],
        [
          3,
          3,
          2,
          2,
          2,
          1,
          1,
          0
        ],
        [
          3,
          3,
          2,
          2,
          2,
          2,
          1,
          0
        ],
        [
          5,
          3,
          3,
          4,
          2,
          2,
          1,
          1
        ],
        [
          5,
          3,
          3,
          4,
          4,
          2,
          1,
          1
        ],
        [
          5,
          6,
          3,
          4,
          4,
          4,
          1,
          1
        ],
        [
          5,
          6,
          6,
          6,
          4,
          7,
          1,
          7
        ],
        [
          6,
          6,
          6,
          7,
          7,
          7,
          7,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 3
        },
        {
          "row": 3,
          "col": 1
        }
      ],
      "solutionColumns": [
        7,
        5,
        3,
        1,
        4,
        0,
        2,
        6
      ],
      "seed": "shibadoku-v1:101:252",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "22c1f64064c03815c17572a3325a081e48c4cd9bb8923539613cb67ee5e71b74",
      "difficulty": {
        "profileId": "8x8-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 84,
        "logicalStepCount": 10
      }
    },
    {
      "id": "campaign-102",
      "levelId": 102,
      "size": 8,
      "regions": [
        [
          0,
          0,
          0,
          0,
          0,
          2,
          2,
          3
        ],
        [
          0,
          0,
          1,
          1,
          0,
          2,
          3,
          3
        ],
        [
          0,
          1,
          1,
          2,
          2,
          2,
          3,
          3
        ],
        [
          6,
          1,
          1,
          4,
          2,
          3,
          3,
          3
        ],
        [
          6,
          1,
          1,
          4,
          2,
          2,
          5,
          5
        ],
        [
          6,
          1,
          4,
          4,
          4,
          4,
          5,
          5
        ],
        [
          6,
          6,
          6,
          4,
          4,
          7,
          7,
          7
        ],
        [
          6,
          6,
          6,
          6,
          4,
          7,
          7,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 7,
          "col": 5
        },
        {
          "row": 3,
          "col": 6
        }
      ],
      "solutionColumns": [
        0,
        2,
        4,
        6,
        3,
        7,
        1,
        5
      ],
      "seed": "shibadoku-v1:102:785",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "b40bdb74302a8b82182fd22dbf23ef591fed57b61fdb566d02ea9cda22ddbb03",
      "difficulty": {
        "profileId": "8x8-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 87,
        "logicalStepCount": 11
      }
    },
    {
      "id": "campaign-103",
      "levelId": 103,
      "size": 8,
      "regions": [
        [
          1,
          1,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          2,
          2,
          0,
          0,
          0
        ],
        [
          1,
          1,
          2,
          2,
          2,
          2,
          2,
          3
        ],
        [
          1,
          1,
          2,
          4,
          4,
          3,
          3,
          3
        ],
        [
          7,
          1,
          7,
          4,
          4,
          3,
          3,
          5
        ],
        [
          7,
          1,
          7,
          4,
          4,
          6,
          6,
          5
        ],
        [
          7,
          7,
          7,
          7,
          4,
          6,
          6,
          5
        ],
        [
          7,
          7,
          7,
          4,
          4,
          6,
          6,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 6,
          "col": 5
        },
        {
          "row": 4,
          "col": 3
        }
      ],
      "solutionColumns": [
        4,
        0,
        2,
        6,
        3,
        7,
        5,
        1
      ],
      "seed": "shibadoku-v1:103:295",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "68b5fc3786744c35f18e5508291fac6cc9471c0a0e821d01831ccab3fc9e7e71",
      "difficulty": {
        "profileId": "8x8-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 92,
        "logicalStepCount": 12
      }
    },
    {
      "id": "campaign-104",
      "levelId": 104,
      "size": 8,
      "regions": [
        [
          1,
          1,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          0,
          0,
          3,
          0,
          3
        ],
        [
          1,
          1,
          2,
          2,
          0,
          3,
          3,
          3
        ],
        [
          2,
          2,
          2,
          2,
          2,
          3,
          3,
          3
        ],
        [
          5,
          5,
          5,
          4,
          4,
          4,
          4,
          3
        ],
        [
          5,
          5,
          5,
          6,
          6,
          4,
          4,
          4
        ],
        [
          5,
          5,
          6,
          6,
          6,
          6,
          7,
          7
        ],
        [
          5,
          5,
          6,
          7,
          7,
          7,
          7,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 6
        },
        {
          "row": 6,
          "col": 4
        }
      ],
      "solutionColumns": [
        5,
        0,
        2,
        6,
        3,
        1,
        4,
        7
      ],
      "seed": "shibadoku-v1:104:239",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "811f2069b33d6a79ff4ea72c4a5b05ccb81d3773d102226b91289c7ccc9775eb",
      "difficulty": {
        "profileId": "8x8-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 93,
        "logicalStepCount": 13
      }
    },
    {
      "id": "campaign-105",
      "levelId": 105,
      "size": 8,
      "regions": [
        [
          2,
          2,
          0,
          0,
          0,
          1,
          1,
          1
        ],
        [
          2,
          2,
          0,
          0,
          0,
          1,
          1,
          4
        ],
        [
          2,
          2,
          2,
          2,
          1,
          1,
          4,
          4
        ],
        [
          2,
          2,
          3,
          3,
          3,
          1,
          6,
          4
        ],
        [
          5,
          2,
          3,
          3,
          3,
          6,
          6,
          4
        ],
        [
          5,
          2,
          3,
          3,
          6,
          6,
          4,
          4
        ],
        [
          5,
          5,
          7,
          7,
          7,
          6,
          6,
          4
        ],
        [
          5,
          5,
          5,
          7,
          7,
          7,
          6,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 3,
          "col": 3
        },
        {
          "row": 6,
          "col": 6
        }
      ],
      "solutionColumns": [
        2,
        5,
        1,
        3,
        7,
        0,
        6,
        4
      ],
      "seed": "shibadoku-v1:105:311",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "d02ad02b32b415fe746ed1800ff9cde731768f80ea540bd0ddb088793cc6c7c3",
      "difficulty": {
        "profileId": "8x8-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 97,
        "logicalStepCount": 14
      }
    },
    {
      "id": "campaign-106",
      "levelId": 106,
      "size": 8,
      "regions": [
        [
          2,
          0,
          0,
          0,
          0,
          1,
          1,
          1
        ],
        [
          2,
          2,
          0,
          0,
          3,
          3,
          1,
          1
        ],
        [
          2,
          2,
          2,
          0,
          3,
          3,
          1,
          1
        ],
        [
          2,
          2,
          2,
          3,
          3,
          7,
          7,
          1
        ],
        [
          4,
          4,
          3,
          3,
          3,
          3,
          7,
          7
        ],
        [
          6,
          4,
          3,
          5,
          5,
          5,
          7,
          7
        ],
        [
          6,
          4,
          3,
          5,
          5,
          5,
          7,
          7
        ],
        [
          6,
          6,
          5,
          5,
          5,
          5,
          5,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 1,
          "col": 6
        },
        {
          "row": 7,
          "col": 7
        }
      ],
      "solutionColumns": [
        3,
        6,
        2,
        4,
        1,
        5,
        0,
        7
      ],
      "seed": "shibadoku-v1:106:82",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "23866f759b38bfd5a22780a18b9cf55a516f3d8aa91fb09147f66c3bdd51a99b",
      "difficulty": {
        "profileId": "8x8-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 100,
        "logicalStepCount": 15
      }
    },
    {
      "id": "campaign-107",
      "levelId": 107,
      "size": 8,
      "regions": [
        [
          4,
          4,
          4,
          0,
          0,
          0,
          1,
          1
        ],
        [
          4,
          4,
          0,
          0,
          0,
          1,
          1,
          1
        ],
        [
          4,
          2,
          2,
          2,
          2,
          3,
          3,
          1
        ],
        [
          4,
          4,
          2,
          5,
          2,
          3,
          3,
          1
        ],
        [
          4,
          4,
          5,
          5,
          6,
          6,
          3,
          3
        ],
        [
          4,
          7,
          5,
          5,
          6,
          6,
          3,
          3
        ],
        [
          7,
          7,
          5,
          5,
          6,
          6,
          6,
          3
        ],
        [
          7,
          7,
          7,
          7,
          6,
          6,
          6,
          6
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 3
        },
        {
          "row": 4,
          "col": 0
        }
      ],
      "solutionColumns": [
        3,
        7,
        4,
        6,
        0,
        2,
        5,
        1
      ],
      "seed": "shibadoku-v1:107:370",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "48301ab5bcdb292bd2a377feb51ac1e8ba859e9aa6a7538edbf1e4c3ad2a0db8",
      "difficulty": {
        "profileId": "8x8-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 102,
        "logicalStepCount": 16
      }
    },
    {
      "id": "campaign-108",
      "levelId": 108,
      "size": 8,
      "regions": [
        [
          1,
          1,
          2,
          0,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          2,
          2,
          0,
          0,
          0,
          0
        ],
        [
          3,
          1,
          2,
          2,
          2,
          0,
          4,
          4
        ],
        [
          3,
          1,
          2,
          5,
          4,
          4,
          4,
          4
        ],
        [
          3,
          3,
          6,
          5,
          5,
          4,
          4,
          4
        ],
        [
          3,
          6,
          6,
          5,
          5,
          5,
          5,
          4
        ],
        [
          3,
          6,
          6,
          6,
          7,
          5,
          7,
          7
        ],
        [
          6,
          6,
          6,
          6,
          7,
          7,
          7,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 4,
          "col": 7
        },
        {
          "row": 0,
          "col": 4
        }
      ],
      "solutionColumns": [
        4,
        1,
        3,
        0,
        7,
        5,
        2,
        6
      ],
      "seed": "shibadoku-v1:108:27",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "3d0f726bf3bf90c750977ab091e364c595f2dfe090e34a8363dc1cf684e524c4",
      "difficulty": {
        "profileId": "8x8-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 105,
        "logicalStepCount": 17
      }
    },
    {
      "id": "campaign-109",
      "levelId": 109,
      "size": 9,
      "regions": [
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          1,
          0,
          0,
          2
        ],
        [
          1,
          4,
          4,
          1,
          1,
          1,
          3,
          2,
          2
        ],
        [
          4,
          4,
          4,
          1,
          3,
          3,
          3,
          2,
          2
        ],
        [
          4,
          4,
          4,
          4,
          3,
          3,
          3,
          3,
          5
        ],
        [
          6,
          4,
          4,
          4,
          7,
          7,
          5,
          5,
          5
        ],
        [
          6,
          6,
          8,
          7,
          7,
          5,
          5,
          5,
          5
        ],
        [
          6,
          8,
          8,
          7,
          7,
          7,
          5,
          5,
          5
        ],
        [
          8,
          8,
          8,
          8,
          7,
          5,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 7,
          "col": 4
        },
        {
          "row": 4,
          "col": 1
        },
        {
          "row": 0,
          "col": 7
        }
      ],
      "solutionColumns": [
        7,
        3,
        8,
        5,
        1,
        6,
        0,
        4,
        2
      ],
      "seed": "shibadoku-v1:109:144",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "3c6dfdf48816eb541d869f48986a3d7943e873d8b62846d9f8778ed2ae0dc951",
      "difficulty": {
        "profileId": "9x9-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 91,
        "logicalStepCount": 10
      }
    },
    {
      "id": "campaign-110",
      "levelId": 110,
      "size": 9,
      "regions": [
        [
          1,
          1,
          2,
          2,
          2,
          0,
          0,
          0,
          0
        ],
        [
          3,
          1,
          1,
          2,
          0,
          0,
          0,
          0,
          0
        ],
        [
          3,
          1,
          1,
          2,
          0,
          0,
          0,
          0,
          0
        ],
        [
          3,
          3,
          1,
          2,
          5,
          5,
          4,
          4,
          4
        ],
        [
          3,
          3,
          3,
          5,
          5,
          5,
          4,
          4,
          4
        ],
        [
          3,
          6,
          6,
          6,
          5,
          5,
          4,
          4,
          7
        ],
        [
          6,
          6,
          6,
          6,
          6,
          6,
          7,
          4,
          7
        ],
        [
          6,
          6,
          8,
          6,
          8,
          8,
          7,
          7,
          7
        ],
        [
          6,
          8,
          8,
          8,
          8,
          8,
          8,
          8,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 5
        },
        {
          "row": 1,
          "col": 1
        },
        {
          "row": 4,
          "col": 7
        }
      ],
      "solutionColumns": [
        5,
        1,
        3,
        0,
        7,
        4,
        2,
        8,
        6
      ],
      "seed": "shibadoku-v1:110:106",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "1b9654acedd4abf4fa0310eb2767c076b64a467921c0cd33a65c1113fa0be29a",
      "difficulty": {
        "profileId": "9x9-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 94,
        "logicalStepCount": 11
      }
    },
    {
      "id": "campaign-111",
      "levelId": 111,
      "size": 9,
      "regions": [
        [
          0,
          0,
          0,
          1,
          1,
          1,
          1,
          1,
          1
        ],
        [
          3,
          0,
          1,
          1,
          2,
          2,
          1,
          1,
          1
        ],
        [
          3,
          0,
          0,
          1,
          2,
          2,
          2,
          2,
          2
        ],
        [
          3,
          3,
          4,
          4,
          4,
          2,
          2,
          2,
          2
        ],
        [
          3,
          3,
          4,
          4,
          6,
          6,
          2,
          5,
          5
        ],
        [
          3,
          4,
          4,
          4,
          6,
          6,
          6,
          5,
          5
        ],
        [
          3,
          4,
          4,
          6,
          6,
          6,
          6,
          5,
          5
        ],
        [
          3,
          4,
          6,
          6,
          6,
          7,
          7,
          7,
          5
        ],
        [
          3,
          4,
          6,
          6,
          7,
          7,
          7,
          8,
          8
        ]
      ],
      "givenShibas": [
        {
          "row": 4,
          "col": 2
        },
        {
          "row": 2,
          "col": 5
        },
        {
          "row": 1,
          "col": 3
        }
      ],
      "solutionColumns": [
        1,
        3,
        5,
        0,
        2,
        7,
        4,
        6,
        8
      ],
      "seed": "shibadoku-v1:111:444",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "78418e1a1c5e033c8c571a8497715a4ba04364c945e08222ad34701af6a702c4",
      "difficulty": {
        "profileId": "9x9-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 97,
        "logicalStepCount": 12
      }
    },
    {
      "id": "campaign-112",
      "levelId": 112,
      "size": 9,
      "regions": [
        [
          1,
          1,
          3,
          3,
          0,
          0,
          2,
          2,
          2
        ],
        [
          1,
          1,
          1,
          3,
          3,
          0,
          2,
          2,
          2
        ],
        [
          1,
          4,
          1,
          4,
          3,
          0,
          2,
          2,
          2
        ],
        [
          1,
          4,
          1,
          4,
          3,
          0,
          0,
          5,
          2
        ],
        [
          4,
          4,
          4,
          4,
          3,
          0,
          5,
          5,
          5
        ],
        [
          6,
          6,
          6,
          4,
          3,
          5,
          5,
          5,
          7
        ],
        [
          8,
          6,
          6,
          6,
          8,
          5,
          5,
          7,
          7
        ],
        [
          8,
          6,
          6,
          8,
          8,
          7,
          7,
          7,
          7
        ],
        [
          8,
          8,
          8,
          8,
          8,
          7,
          7,
          7,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 4,
          "col": 1
        },
        {
          "row": 2,
          "col": 6
        },
        {
          "row": 6,
          "col": 2
        }
      ],
      "solutionColumns": [
        5,
        0,
        6,
        4,
        1,
        7,
        2,
        8,
        3
      ],
      "seed": "shibadoku-v1:112:241",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "4b326cc3d15aad6b21c2d7d364ab2c77872bd50ae290d7a614bc86ff458fed19",
      "difficulty": {
        "profileId": "9x9-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 100,
        "logicalStepCount": 13
      }
    },
    {
      "id": "campaign-113",
      "levelId": 113,
      "size": 9,
      "regions": [
        [
          5,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        [
          5,
          5,
          5,
          2,
          2,
          1,
          1,
          0,
          0
        ],
        [
          5,
          5,
          5,
          2,
          2,
          1,
          1,
          1,
          0
        ],
        [
          6,
          6,
          5,
          2,
          2,
          1,
          3,
          3,
          4
        ],
        [
          6,
          6,
          5,
          5,
          2,
          3,
          3,
          4,
          4
        ],
        [
          6,
          6,
          5,
          5,
          3,
          3,
          3,
          4,
          4
        ],
        [
          6,
          8,
          8,
          5,
          7,
          3,
          7,
          4,
          4
        ],
        [
          6,
          8,
          7,
          7,
          7,
          7,
          7,
          4,
          4
        ],
        [
          6,
          8,
          8,
          8,
          7,
          7,
          7,
          7,
          4
        ]
      ],
      "givenShibas": [
        {
          "row": 4,
          "col": 8
        },
        {
          "row": 5,
          "col": 2
        },
        {
          "row": 1,
          "col": 5
        }
      ],
      "solutionColumns": [
        7,
        5,
        3,
        6,
        8,
        2,
        0,
        4,
        1
      ],
      "seed": "shibadoku-v1:113:243",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "8a3a2a01a9e7992bf4b36a05c77215321fcde02704cb7237e2903c83e10e7356",
      "difficulty": {
        "profileId": "9x9-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 103,
        "logicalStepCount": 14
      }
    },
    {
      "id": "campaign-114",
      "levelId": 114,
      "size": 9,
      "regions": [
        [
          2,
          2,
          2,
          0,
          0,
          0,
          1,
          1,
          1
        ],
        [
          2,
          2,
          2,
          0,
          3,
          0,
          1,
          1,
          1
        ],
        [
          2,
          2,
          2,
          3,
          3,
          3,
          1,
          4,
          4
        ],
        [
          2,
          2,
          2,
          2,
          3,
          3,
          4,
          4,
          4
        ],
        [
          2,
          2,
          2,
          2,
          6,
          3,
          3,
          5,
          4
        ],
        [
          6,
          6,
          6,
          6,
          6,
          3,
          5,
          5,
          5
        ],
        [
          8,
          6,
          6,
          7,
          6,
          7,
          5,
          5,
          5
        ],
        [
          8,
          8,
          6,
          7,
          7,
          7,
          5,
          5,
          5
        ],
        [
          8,
          8,
          7,
          7,
          7,
          7,
          7,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 4
        },
        {
          "row": 5,
          "col": 6
        },
        {
          "row": 2,
          "col": 2
        }
      ],
      "solutionColumns": [
        4,
        7,
        2,
        5,
        8,
        6,
        1,
        3,
        0
      ],
      "seed": "shibadoku-v1:114:96",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "da51ff3199174386f40753e0c9a1c1a68d7da4fedd3ffc91187b1993d62807ec",
      "difficulty": {
        "profileId": "9x9-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 106,
        "logicalStepCount": 15
      }
    },
    {
      "id": "campaign-115",
      "levelId": 115,
      "size": 9,
      "regions": [
        [
          3,
          3,
          1,
          1,
          1,
          1,
          1,
          0,
          0
        ],
        [
          3,
          3,
          3,
          1,
          1,
          1,
          1,
          2,
          2
        ],
        [
          7,
          4,
          3,
          3,
          3,
          3,
          2,
          2,
          2
        ],
        [
          7,
          4,
          3,
          3,
          3,
          4,
          5,
          2,
          2
        ],
        [
          7,
          4,
          4,
          4,
          4,
          4,
          5,
          5,
          5
        ],
        [
          7,
          6,
          6,
          6,
          6,
          5,
          5,
          5,
          5
        ],
        [
          7,
          7,
          6,
          6,
          5,
          5,
          8,
          5,
          5
        ],
        [
          7,
          7,
          8,
          8,
          8,
          8,
          8,
          5,
          5
        ],
        [
          7,
          8,
          8,
          8,
          8,
          8,
          8,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 7
        },
        {
          "row": 6,
          "col": 3
        }
      ],
      "solutionColumns": [
        8,
        5,
        7,
        4,
        1,
        6,
        3,
        0,
        2
      ],
      "seed": "shibadoku-v1:115:340",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "06da286af817ae502ee8eb5f56b24a3cad32534e9c01810c5930ce2fd8d957e4",
      "difficulty": {
        "profileId": "9x9-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 112,
        "logicalStepCount": 16
      }
    },
    {
      "id": "campaign-116",
      "levelId": 116,
      "size": 9,
      "regions": [
        [
          1,
          1,
          1,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          1,
          3,
          0,
          3,
          2,
          2
        ],
        [
          1,
          1,
          3,
          1,
          3,
          3,
          3,
          2,
          2
        ],
        [
          4,
          4,
          3,
          3,
          3,
          3,
          3,
          6,
          2
        ],
        [
          4,
          4,
          5,
          5,
          5,
          8,
          6,
          6,
          6
        ],
        [
          5,
          5,
          5,
          5,
          7,
          8,
          8,
          8,
          6
        ],
        [
          5,
          5,
          5,
          7,
          7,
          8,
          6,
          6,
          6
        ],
        [
          7,
          7,
          7,
          7,
          8,
          8,
          8,
          8,
          6
        ],
        [
          7,
          7,
          7,
          7,
          7,
          8,
          8,
          6,
          6
        ]
      ],
      "givenShibas": [
        {
          "row": 6,
          "col": 8
        },
        {
          "row": 0,
          "col": 6
        },
        {
          "row": 7,
          "col": 3
        }
      ],
      "solutionColumns": [
        6,
        1,
        7,
        4,
        0,
        2,
        8,
        3,
        5
      ],
      "seed": "shibadoku-v1:116:29",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "a556f21a6ab20953bfc0de6f46bbbab2c601977859ecb6b22c54dd247f58dcb1",
      "difficulty": {
        "profileId": "9x9-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 118,
        "logicalStepCount": 18
      }
    },
    {
      "id": "campaign-117",
      "levelId": 117,
      "size": 9,
      "regions": [
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          2,
          0,
          0,
          0,
          0,
          0
        ],
        [
          3,
          3,
          2,
          2,
          2,
          2,
          0,
          0,
          4
        ],
        [
          3,
          3,
          2,
          2,
          2,
          2,
          2,
          2,
          4
        ],
        [
          3,
          3,
          3,
          5,
          4,
          4,
          4,
          4,
          4
        ],
        [
          3,
          3,
          5,
          5,
          5,
          5,
          4,
          4,
          4
        ],
        [
          8,
          8,
          5,
          5,
          6,
          6,
          6,
          6,
          4
        ],
        [
          8,
          8,
          8,
          8,
          8,
          6,
          6,
          7,
          7
        ],
        [
          8,
          8,
          8,
          8,
          7,
          7,
          7,
          7,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 8,
          "col": 1
        },
        {
          "row": 2,
          "col": 4
        },
        {
          "row": 0,
          "col": 5
        }
      ],
      "solutionColumns": [
        5,
        2,
        4,
        0,
        7,
        3,
        6,
        8,
        1
      ],
      "seed": "shibadoku-v1:117:426",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "fb2943cabf15a158bad23c84cf3571c944842690ddfd0f6179655d34e435675a",
      "difficulty": {
        "profileId": "9x9-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 115,
        "logicalStepCount": 18
      }
    },
    {
      "id": "campaign-118",
      "levelId": 118,
      "size": 9,
      "regions": [
        [
          3,
          3,
          0,
          0,
          0,
          0,
          0,
          1,
          1
        ],
        [
          3,
          3,
          2,
          2,
          0,
          2,
          0,
          1,
          1
        ],
        [
          3,
          3,
          2,
          2,
          2,
          2,
          0,
          1,
          1
        ],
        [
          3,
          3,
          4,
          4,
          4,
          2,
          1,
          1,
          1
        ],
        [
          3,
          5,
          6,
          4,
          4,
          4,
          1,
          1,
          7
        ],
        [
          5,
          5,
          6,
          6,
          6,
          4,
          4,
          4,
          7
        ],
        [
          5,
          5,
          6,
          6,
          7,
          7,
          7,
          4,
          7
        ],
        [
          5,
          5,
          8,
          6,
          6,
          7,
          7,
          7,
          7
        ],
        [
          8,
          8,
          8,
          6,
          7,
          7,
          7,
          7,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 1,
          "col": 8
        },
        {
          "row": 2,
          "col": 5
        },
        {
          "row": 5,
          "col": 0
        }
      ],
      "solutionColumns": [
        6,
        8,
        5,
        1,
        4,
        0,
        3,
        7,
        2
      ],
      "seed": "shibadoku-v1:118:840",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "43e54fa9d4dadccf3b48a3943ee3e1d939b55e2eb0af66f0def792970209d451",
      "difficulty": {
        "profileId": "9x9-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 91,
        "logicalStepCount": 10
      }
    },
    {
      "id": "campaign-119",
      "levelId": 119,
      "size": 9,
      "regions": [
        [
          0,
          0,
          0,
          0,
          0,
          2,
          1,
          1,
          1
        ],
        [
          0,
          3,
          3,
          3,
          2,
          2,
          2,
          1,
          1
        ],
        [
          5,
          3,
          3,
          3,
          2,
          4,
          1,
          1,
          4
        ],
        [
          5,
          3,
          3,
          3,
          2,
          4,
          4,
          4,
          4
        ],
        [
          5,
          5,
          5,
          4,
          4,
          4,
          4,
          4,
          4
        ],
        [
          5,
          5,
          5,
          6,
          6,
          8,
          4,
          4,
          7
        ],
        [
          5,
          6,
          6,
          6,
          6,
          8,
          7,
          7,
          7
        ],
        [
          5,
          5,
          6,
          6,
          6,
          8,
          8,
          7,
          7
        ],
        [
          6,
          6,
          6,
          8,
          8,
          8,
          8,
          7,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 6,
          "col": 2
        },
        {
          "row": 7,
          "col": 7
        },
        {
          "row": 2,
          "col": 4
        }
      ],
      "solutionColumns": [
        3,
        8,
        4,
        1,
        6,
        0,
        2,
        7,
        5
      ],
      "seed": "shibadoku-v1:119:163",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "21c6c16c5b5509d730b29aee998a27f894bd4e71a516fc0238ac8c99d6cb54f1",
      "difficulty": {
        "profileId": "9x9-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 97,
        "logicalStepCount": 11
      }
    },
    {
      "id": "campaign-120",
      "levelId": 120,
      "size": 9,
      "regions": [
        [
          3,
          1,
          1,
          0,
          0,
          0,
          2,
          2,
          2
        ],
        [
          3,
          3,
          1,
          1,
          1,
          0,
          2,
          2,
          4
        ],
        [
          3,
          3,
          1,
          1,
          1,
          2,
          2,
          4,
          4
        ],
        [
          5,
          3,
          3,
          1,
          1,
          2,
          2,
          4,
          4
        ],
        [
          5,
          3,
          3,
          7,
          1,
          2,
          7,
          4,
          4
        ],
        [
          5,
          5,
          7,
          7,
          7,
          7,
          7,
          4,
          6
        ],
        [
          5,
          5,
          8,
          8,
          8,
          7,
          7,
          4,
          6
        ],
        [
          5,
          5,
          5,
          8,
          7,
          7,
          7,
          4,
          6
        ],
        [
          5,
          5,
          8,
          8,
          8,
          7,
          7,
          4,
          6
        ]
      ],
      "givenShibas": [
        {
          "row": 7,
          "col": 5
        },
        {
          "row": 5,
          "col": 0
        },
        {
          "row": 8,
          "col": 3
        }
      ],
      "solutionColumns": [
        4,
        2,
        6,
        1,
        7,
        0,
        8,
        5,
        3
      ],
      "seed": "shibadoku-v1:120:34",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "a4bcec5b29cfb645a41aa82780902366324b786bdae3080979f68aa5334e42a2",
      "difficulty": {
        "profileId": "9x9-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 107,
        "logicalStepCount": 14
      }
    },
    {
      "id": "campaign-121",
      "levelId": 121,
      "size": 9,
      "regions": [
        [
          1,
          1,
          1,
          1,
          3,
          2,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          3,
          3,
          2,
          2,
          0,
          0
        ],
        [
          1,
          1,
          1,
          3,
          3,
          3,
          2,
          2,
          4
        ],
        [
          1,
          3,
          3,
          3,
          3,
          3,
          2,
          4,
          4
        ],
        [
          1,
          6,
          3,
          6,
          5,
          5,
          2,
          4,
          4
        ],
        [
          6,
          6,
          6,
          6,
          5,
          5,
          7,
          4,
          4
        ],
        [
          8,
          8,
          6,
          5,
          5,
          7,
          7,
          4,
          4
        ],
        [
          8,
          8,
          6,
          6,
          6,
          7,
          7,
          7,
          7
        ],
        [
          8,
          8,
          8,
          6,
          6,
          7,
          7,
          7,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 8,
          "col": 1
        },
        {
          "row": 4,
          "col": 7
        },
        {
          "row": 1,
          "col": 0
        }
      ],
      "solutionColumns": [
        8,
        0,
        6,
        3,
        7,
        4,
        2,
        5,
        1
      ],
      "seed": "shibadoku-v1:121:561",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "90a1c7a20d696d336b9f38c8659fb7532fd236f0d16fac6ce3ebb7fdf96ec1e8",
      "difficulty": {
        "profileId": "9x9-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 100,
        "logicalStepCount": 13
      }
    },
    {
      "id": "campaign-122",
      "levelId": 122,
      "size": 9,
      "regions": [
        [
          1,
          1,
          1,
          1,
          2,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          1,
          2,
          2,
          2,
          0,
          0
        ],
        [
          1,
          3,
          2,
          2,
          2,
          2,
          2,
          0,
          0
        ],
        [
          1,
          3,
          3,
          2,
          2,
          2,
          0,
          0,
          0
        ],
        [
          4,
          4,
          4,
          4,
          7,
          7,
          5,
          0,
          0
        ],
        [
          6,
          6,
          6,
          4,
          7,
          5,
          5,
          5,
          5
        ],
        [
          6,
          6,
          6,
          4,
          7,
          7,
          5,
          5,
          5
        ],
        [
          6,
          6,
          6,
          6,
          7,
          7,
          5,
          5,
          8
        ],
        [
          6,
          6,
          6,
          6,
          6,
          7,
          5,
          8,
          8
        ]
      ],
      "givenShibas": [
        {
          "row": 1,
          "col": 0
        },
        {
          "row": 5,
          "col": 7
        },
        {
          "row": 7,
          "col": 5
        }
      ],
      "solutionColumns": [
        6,
        0,
        4,
        1,
        3,
        7,
        2,
        5,
        8
      ],
      "seed": "shibadoku-v1:122:35",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "646c3c394c5063f25203167c5bd2feb4bcaec12656555abea53084dcc71d1478",
      "difficulty": {
        "profileId": "9x9-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 103,
        "logicalStepCount": 14
      }
    },
    {
      "id": "campaign-123",
      "levelId": 123,
      "size": 9,
      "regions": [
        [
          2,
          2,
          2,
          0,
          0,
          0,
          0,
          0,
          1
        ],
        [
          2,
          2,
          2,
          2,
          2,
          0,
          1,
          0,
          1
        ],
        [
          5,
          2,
          2,
          2,
          2,
          0,
          1,
          1,
          1
        ],
        [
          5,
          5,
          2,
          2,
          4,
          6,
          3,
          3,
          1
        ],
        [
          5,
          5,
          5,
          4,
          4,
          6,
          6,
          3,
          3
        ],
        [
          5,
          5,
          5,
          4,
          6,
          6,
          6,
          3,
          3
        ],
        [
          7,
          7,
          4,
          4,
          6,
          6,
          3,
          3,
          3
        ],
        [
          7,
          7,
          4,
          8,
          6,
          6,
          8,
          3,
          8
        ],
        [
          7,
          7,
          7,
          8,
          8,
          8,
          8,
          8,
          8
        ]
      ],
      "givenShibas": [
        {
          "row": 6,
          "col": 4
        },
        {
          "row": 0,
          "col": 6
        },
        {
          "row": 5,
          "col": 1
        }
      ],
      "solutionColumns": [
        6,
        8,
        2,
        7,
        3,
        1,
        4,
        0,
        5
      ],
      "seed": "shibadoku-v1:123:187",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "d3b9c2b717d3f68ff206e569cc8d194e5d1377d9730f9c99f8ff611886dbfdf7",
      "difficulty": {
        "profileId": "9x9-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 107,
        "logicalStepCount": 15
      }
    },
    {
      "id": "campaign-124",
      "levelId": 124,
      "size": 9,
      "regions": [
        [
          1,
          1,
          0,
          0,
          0,
          0,
          0,
          4,
          4
        ],
        [
          1,
          1,
          0,
          2,
          2,
          2,
          2,
          4,
          4
        ],
        [
          1,
          3,
          2,
          2,
          2,
          2,
          4,
          4,
          4
        ],
        [
          1,
          3,
          3,
          3,
          2,
          2,
          5,
          4,
          4
        ],
        [
          3,
          3,
          3,
          3,
          7,
          7,
          5,
          4,
          4
        ],
        [
          6,
          6,
          6,
          7,
          7,
          7,
          5,
          5,
          4
        ],
        [
          6,
          6,
          6,
          7,
          7,
          7,
          5,
          5,
          5
        ],
        [
          6,
          6,
          6,
          6,
          6,
          7,
          8,
          8,
          5
        ],
        [
          6,
          6,
          6,
          6,
          8,
          8,
          8,
          8,
          8
        ]
      ],
      "givenShibas": [
        {
          "row": 2,
          "col": 4
        },
        {
          "row": 6,
          "col": 2
        },
        {
          "row": 4,
          "col": 8
        }
      ],
      "solutionColumns": [
        3,
        0,
        4,
        1,
        8,
        6,
        2,
        5,
        7
      ],
      "seed": "shibadoku-v1:124:187",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "77bcaa3251053ed33d18889d342b82d0b94204125b87354e8727c530e2ec1ff3",
      "difficulty": {
        "profileId": "9x9-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 110,
        "logicalStepCount": 16
      }
    },
    {
      "id": "campaign-125",
      "levelId": 125,
      "size": 9,
      "regions": [
        [
          2,
          2,
          2,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        [
          2,
          2,
          2,
          1,
          1,
          1,
          0,
          0,
          0
        ],
        [
          2,
          2,
          1,
          1,
          1,
          3,
          3,
          0,
          3
        ],
        [
          5,
          5,
          1,
          1,
          4,
          3,
          3,
          3,
          3
        ],
        [
          5,
          5,
          5,
          4,
          4,
          3,
          3,
          3,
          7
        ],
        [
          6,
          5,
          5,
          5,
          4,
          3,
          7,
          7,
          7
        ],
        [
          6,
          6,
          6,
          8,
          4,
          4,
          4,
          7,
          7
        ],
        [
          6,
          6,
          8,
          8,
          4,
          4,
          4,
          7,
          7
        ],
        [
          6,
          6,
          8,
          8,
          8,
          7,
          7,
          7,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 5,
          "col": 2
        },
        {
          "row": 7,
          "col": 8
        },
        {
          "row": 3,
          "col": 6
        }
      ],
      "solutionColumns": [
        7,
        5,
        1,
        6,
        4,
        2,
        0,
        8,
        3
      ],
      "seed": "shibadoku-v1:125:68",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "62c645a87940c9d6db04f289844628d1cdcf715f44c1ac4244c9e93bd803a676",
      "difficulty": {
        "profileId": "9x9-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 114,
        "logicalStepCount": 17
      }
    },
    {
      "id": "campaign-126",
      "levelId": 126,
      "size": 9,
      "regions": [
        [
          1,
          1,
          1,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          0,
          0,
          3,
          3,
          3,
          0
        ],
        [
          1,
          1,
          4,
          2,
          0,
          3,
          3,
          3,
          3
        ],
        [
          1,
          4,
          4,
          2,
          2,
          3,
          3,
          3,
          3
        ],
        [
          6,
          6,
          4,
          4,
          2,
          3,
          3,
          5,
          3
        ],
        [
          6,
          6,
          6,
          4,
          2,
          3,
          5,
          5,
          5
        ],
        [
          6,
          6,
          8,
          8,
          8,
          8,
          5,
          7,
          5
        ],
        [
          6,
          6,
          8,
          8,
          8,
          8,
          8,
          7,
          7
        ],
        [
          6,
          6,
          6,
          8,
          8,
          8,
          8,
          8,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 1,
          "col": 1
        },
        {
          "row": 4,
          "col": 2
        },
        {
          "row": 8,
          "col": 6
        }
      ],
      "solutionColumns": [
        4,
        1,
        3,
        5,
        2,
        7,
        0,
        8,
        6
      ],
      "seed": "shibadoku-v1:126:24",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "a3641636681956b88073f819ce570809bbe6b5bbe13ca4bf3a0d98d1b441d4f1",
      "difficulty": {
        "profileId": "9x9-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 117,
        "logicalStepCount": 18
      }
    },
    {
      "id": "campaign-127",
      "levelId": 127,
      "size": 9,
      "regions": [
        [
          1,
          1,
          1,
          0,
          0,
          2,
          2,
          2,
          2
        ],
        [
          3,
          1,
          3,
          0,
          2,
          2,
          2,
          4,
          4
        ],
        [
          3,
          3,
          3,
          3,
          2,
          2,
          2,
          4,
          4
        ],
        [
          7,
          3,
          3,
          2,
          2,
          2,
          4,
          4,
          4
        ],
        [
          7,
          3,
          7,
          6,
          4,
          4,
          4,
          4,
          5
        ],
        [
          7,
          7,
          7,
          6,
          6,
          6,
          5,
          5,
          5
        ],
        [
          7,
          7,
          7,
          6,
          6,
          6,
          6,
          6,
          8
        ],
        [
          7,
          7,
          7,
          6,
          6,
          8,
          8,
          6,
          8
        ],
        [
          7,
          7,
          8,
          8,
          8,
          8,
          8,
          8,
          8
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 3
        },
        {
          "row": 2,
          "col": 5
        },
        {
          "row": 6,
          "col": 4
        }
      ],
      "solutionColumns": [
        3,
        1,
        5,
        2,
        6,
        8,
        4,
        0,
        7
      ],
      "seed": "shibadoku-v1:127:26",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "b20e2187b11b06eaa33a5aa0aa5c2d94d41f19b37403106656800e082fd68a1b",
      "difficulty": {
        "profileId": "9x9-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 91,
        "logicalStepCount": 10
      }
    },
    {
      "id": "campaign-128",
      "levelId": 128,
      "size": 9,
      "regions": [
        [
          3,
          3,
          0,
          0,
          0,
          0,
          0,
          0,
          2
        ],
        [
          3,
          0,
          0,
          0,
          1,
          1,
          2,
          2,
          2
        ],
        [
          3,
          3,
          1,
          1,
          1,
          2,
          2,
          2,
          2
        ],
        [
          3,
          1,
          1,
          1,
          1,
          4,
          4,
          2,
          2
        ],
        [
          8,
          8,
          6,
          6,
          4,
          4,
          4,
          5,
          5
        ],
        [
          8,
          6,
          6,
          6,
          6,
          4,
          4,
          5,
          5
        ],
        [
          8,
          6,
          6,
          6,
          6,
          6,
          4,
          5,
          5
        ],
        [
          8,
          8,
          8,
          7,
          7,
          6,
          6,
          5,
          5
        ],
        [
          8,
          8,
          7,
          7,
          7,
          7,
          7,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 1,
          "col": 4
        },
        {
          "row": 7,
          "col": 3
        },
        {
          "row": 5,
          "col": 8
        }
      ],
      "solutionColumns": [
        2,
        4,
        7,
        0,
        6,
        8,
        5,
        3,
        1
      ],
      "seed": "shibadoku-v1:128:81",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "eae57e7b0dfe648d1997db0c2a7cbb3431629fba6cbbebe780e8d4bfbbae6c26",
      "difficulty": {
        "profileId": "9x9-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 95,
        "logicalStepCount": 11
      }
    },
    {
      "id": "campaign-129",
      "levelId": 129,
      "size": 9,
      "regions": [
        [
          2,
          2,
          2,
          2,
          2,
          1,
          0,
          0,
          0
        ],
        [
          2,
          2,
          2,
          2,
          2,
          1,
          1,
          0,
          0
        ],
        [
          2,
          2,
          2,
          2,
          2,
          1,
          3,
          0,
          0
        ],
        [
          2,
          4,
          4,
          4,
          1,
          1,
          3,
          3,
          3
        ],
        [
          4,
          4,
          4,
          4,
          4,
          4,
          3,
          3,
          3
        ],
        [
          5,
          5,
          5,
          5,
          4,
          7,
          7,
          7,
          7
        ],
        [
          6,
          6,
          5,
          5,
          4,
          7,
          7,
          7,
          7
        ],
        [
          6,
          8,
          5,
          5,
          7,
          7,
          7,
          7,
          7
        ],
        [
          8,
          8,
          5,
          5,
          7,
          7,
          7,
          7,
          7
        ]
      ],
      "givenShibas": [
        {
          "row": 4,
          "col": 4
        },
        {
          "row": 1,
          "col": 6
        }
      ],
      "solutionColumns": [
        8,
        6,
        3,
        7,
        4,
        2,
        0,
        5,
        1
      ],
      "seed": "shibadoku-v1:129:69",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "7f4b964d717a82e014a22b5b41d9f071a6ee23b7e64125fed923abbcdb8cd09c",
      "difficulty": {
        "profileId": "9x9-easy",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 97,
        "logicalStepCount": 12
      }
    },
    {
      "id": "campaign-130",
      "levelId": 130,
      "size": 9,
      "regions": [
        [
          1,
          1,
          1,
          1,
          0,
          0,
          0,
          0,
          0
        ],
        [
          1,
          1,
          1,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        [
          2,
          1,
          1,
          1,
          4,
          3,
          0,
          3,
          3
        ],
        [
          2,
          2,
          1,
          4,
          4,
          3,
          3,
          3,
          5
        ],
        [
          2,
          2,
          2,
          4,
          4,
          3,
          5,
          5,
          5
        ],
        [
          8,
          2,
          2,
          6,
          4,
          4,
          4,
          5,
          5
        ],
        [
          8,
          2,
          2,
          6,
          6,
          6,
          7,
          7,
          5
        ],
        [
          8,
          8,
          6,
          6,
          6,
          7,
          7,
          7,
          5
        ],
        [
          8,
          8,
          8,
          6,
          7,
          7,
          7,
          7,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 7,
          "col": 5
        },
        {
          "row": 4,
          "col": 4
        },
        {
          "row": 0,
          "col": 7
        }
      ],
      "solutionColumns": [
        7,
        2,
        0,
        6,
        4,
        8,
        3,
        5,
        1
      ],
      "seed": "shibadoku-v1:130:116",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "11509c9f064dd5cee387163dd42bef7b98ad9e549ae46720a58ff8a6df3f0dd0",
      "difficulty": {
        "profileId": "9x9-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 100,
        "logicalStepCount": 13
      }
    },
    {
      "id": "campaign-131",
      "levelId": 131,
      "size": 9,
      "regions": [
        [
          4,
          4,
          4,
          4,
          4,
          0,
          0,
          0,
          0
        ],
        [
          5,
          4,
          4,
          4,
          4,
          1,
          1,
          0,
          2
        ],
        [
          5,
          5,
          5,
          3,
          4,
          1,
          1,
          2,
          2
        ],
        [
          5,
          5,
          3,
          3,
          4,
          1,
          1,
          2,
          2
        ],
        [
          5,
          5,
          3,
          3,
          4,
          4,
          4,
          2,
          2
        ],
        [
          7,
          5,
          5,
          3,
          6,
          4,
          4,
          8,
          8
        ],
        [
          7,
          5,
          5,
          6,
          6,
          6,
          4,
          8,
          8
        ],
        [
          7,
          7,
          7,
          6,
          6,
          8,
          4,
          8,
          8
        ],
        [
          7,
          7,
          7,
          6,
          6,
          8,
          8,
          8,
          8
        ]
      ],
      "givenShibas": [
        {
          "row": 0,
          "col": 7
        },
        {
          "row": 6,
          "col": 3
        },
        {
          "row": 2,
          "col": 8
        }
      ],
      "solutionColumns": [
        7,
        5,
        8,
        2,
        4,
        1,
        3,
        0,
        6
      ],
      "seed": "shibadoku-v1:131:62",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "b66dca799776e0f19dee8393daf51e5b2da6d59004e4d49fe171a7a975b9549a",
      "difficulty": {
        "profileId": "9x9-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 103,
        "logicalStepCount": 14
      }
    },
    {
      "id": "campaign-132",
      "levelId": 132,
      "size": 9,
      "regions": [
        [
          2,
          1,
          1,
          0,
          0,
          0,
          0,
          3,
          3
        ],
        [
          2,
          1,
          1,
          0,
          0,
          0,
          0,
          3,
          3
        ],
        [
          2,
          2,
          1,
          1,
          1,
          1,
          0,
          3,
          3
        ],
        [
          4,
          4,
          5,
          5,
          0,
          0,
          0,
          0,
          3
        ],
        [
          4,
          4,
          4,
          5,
          5,
          6,
          6,
          6,
          3
        ],
        [
          4,
          7,
          5,
          5,
          5,
          5,
          6,
          6,
          3
        ],
        [
          4,
          7,
          7,
          7,
          5,
          5,
          6,
          6,
          6
        ],
        [
          4,
          7,
          7,
          7,
          8,
          8,
          8,
          6,
          6
        ],
        [
          4,
          7,
          7,
          8,
          8,
          8,
          8,
          6,
          6
        ]
      ],
      "givenShibas": [
        {
          "row": 1,
          "col": 2
        },
        {
          "row": 0,
          "col": 5
        }
      ],
      "solutionColumns": [
        5,
        2,
        0,
        8,
        1,
        4,
        7,
        3,
        6
      ],
      "seed": "shibadoku-v1:132:426",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "09981e0ee99a6c2c25d8960365780569b09dded1838c91923b0487ad4f01f716",
      "difficulty": {
        "profileId": "9x9-medium",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 106,
        "logicalStepCount": 15
      }
    },
    {
      "id": "campaign-133",
      "levelId": 133,
      "size": 9,
      "regions": [
        [
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          4,
          4
        ],
        [
          0,
          0,
          2,
          0,
          1,
          1,
          1,
          4,
          4
        ],
        [
          3,
          2,
          2,
          1,
          1,
          1,
          1,
          4,
          4
        ],
        [
          3,
          3,
          3,
          3,
          1,
          1,
          4,
          4,
          4
        ],
        [
          3,
          3,
          3,
          3,
          5,
          5,
          4,
          4,
          4
        ],
        [
          3,
          3,
          5,
          5,
          5,
          5,
          6,
          6,
          6
        ],
        [
          7,
          7,
          7,
          5,
          5,
          7,
          7,
          8,
          6
        ],
        [
          7,
          7,
          7,
          7,
          7,
          7,
          8,
          8,
          6
        ],
        [
          7,
          7,
          7,
          7,
          7,
          7,
          8,
          8,
          8
        ]
      ],
      "givenShibas": [
        {
          "row": 4,
          "col": 7
        },
        {
          "row": 3,
          "col": 0
        },
        {
          "row": 7,
          "col": 4
        }
      ],
      "solutionColumns": [
        1,
        5,
        2,
        0,
        7,
        3,
        8,
        4,
        6
      ],
      "seed": "shibadoku-v1:133:444",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "2ff9e222b332f0bf3b20a457d043a50c03e371140c91acb77be655c193087027",
      "difficulty": {
        "profileId": "9x9-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 110,
        "logicalStepCount": 16
      }
    },
    {
      "id": "campaign-134",
      "levelId": 134,
      "size": 9,
      "regions": [
        [
          0,
          0,
          0,
          0,
          0,
          1,
          2,
          2,
          3
        ],
        [
          0,
          0,
          0,
          1,
          1,
          1,
          1,
          2,
          3
        ],
        [
          0,
          1,
          1,
          1,
          1,
          1,
          2,
          2,
          3
        ],
        [
          1,
          1,
          4,
          4,
          4,
          2,
          2,
          3,
          3
        ],
        [
          7,
          4,
          4,
          4,
          4,
          4,
          4,
          5,
          3
        ],
        [
          7,
          6,
          6,
          6,
          4,
          5,
          5,
          5,
          5
        ],
        [
          7,
          6,
          6,
          6,
          6,
          5,
          5,
          5,
          5
        ],
        [
          7,
          7,
          7,
          8,
          8,
          8,
          8,
          5,
          5
        ],
        [
          7,
          7,
          8,
          8,
          8,
          5,
          5,
          5,
          5
        ]
      ],
      "givenShibas": [
        {
          "row": 7,
          "col": 0
        },
        {
          "row": 6,
          "col": 2
        },
        {
          "row": 1,
          "col": 4
        }
      ],
      "solutionColumns": [
        1,
        4,
        6,
        8,
        5,
        7,
        2,
        0,
        3
      ],
      "seed": "shibadoku-v1:134:613",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "7b81276f078f5a805d3640ef171a8cfb5b43680e57d648a6a802d72f228a4242",
      "difficulty": {
        "profileId": "9x9-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 114,
        "logicalStepCount": 17
      }
    },
    {
      "id": "campaign-135",
      "levelId": 135,
      "size": 9,
      "regions": [
        [
          3,
          3,
          3,
          1,
          0,
          0,
          0,
          2,
          2
        ],
        [
          3,
          3,
          1,
          1,
          1,
          0,
          0,
          2,
          2
        ],
        [
          3,
          1,
          1,
          1,
          1,
          0,
          2,
          2,
          2
        ],
        [
          3,
          3,
          3,
          4,
          4,
          0,
          2,
          6,
          2
        ],
        [
          3,
          5,
          4,
          4,
          4,
          4,
          2,
          6,
          6
        ],
        [
          3,
          5,
          5,
          5,
          4,
          4,
          6,
          6,
          6
        ],
        [
          5,
          5,
          7,
          7,
          7,
          7,
          6,
          6,
          6
        ],
        [
          5,
          7,
          7,
          7,
          8,
          7,
          8,
          8,
          6
        ],
        [
          7,
          7,
          7,
          8,
          8,
          8,
          8,
          8,
          8
        ]
      ],
      "givenShibas": [
        {
          "row": 6,
          "col": 8
        },
        {
          "row": 7,
          "col": 2
        },
        {
          "row": 2,
          "col": 6
        }
      ],
      "solutionColumns": [
        5,
        3,
        6,
        0,
        4,
        1,
        8,
        2,
        7
      ],
      "seed": "shibadoku-v1:135:974",
      "generatorVersion": "shibadoku-generator-v1",
      "contentHash": "036b2b1be82d09ddb5cb8ad1ab857c97d03fd301e525430d5304cb992b13fb2a",
      "difficulty": {
        "profileId": "9x9-advanced",
        "ratingVersion": "logic-rating-v1",
        "maxRule": "L4",
        "score": 116,
        "logicalStepCount": 18
      }
    }
  ]
}